<template>
  <div class = "fixed-content">
    <div>
      <outbound-booking ref="OutboundBooking" mode="YY" stage="X" :action="onrefresh"/>
      <outbound-booking ref="OutboundBookingYI" mode="YI" stage="X" :action="onrefresh"/>
      <outbound-booking ref="OutboundBookingYT" mode="YT" stage="X" :action="onrefresh"/>
      <outbound-booking ref="OutboundBookingYE" mode="YE" stage="X" :action="onrefresh"/>
      <stage-outbound-booking ref="EmptyOutAssignBooking" mode="YY" stage="X" :action="onstagerefresh"/>
      <stage-outbound-booking ref="EmptyOutAssignBookingYI" mode="YI" stage="X" :action="onstagerefresh"/>
      <stage-outbound-booking ref="EmptyOutAssignBookingYT" mode="YT" stage="X" :action="onstagerefresh"/>
      <stage-outbound-booking ref="EmptyOutAssignBookingYE" mode="YE" stage="X" :action="onstagerefresh"/>
         <callingApiCenter :paths="['/api/w/gst/WebSearchCockpit' ,
            '/api/w/gst/updateyardstage','/api/w/gst/createyardstage','/api/w/stc/updateDispatchSend','/api/w/DOs/WebUnAssignBooking',
            '/api/w/gst/WebConfirmLoad']">
         <md-button class="md-raised custButton "  @click="doAction" ><span class="icons-center material-icons">arrow_back</span>BACK</md-button>
         <md-button class="md-raised custButton "  :disabled="canLast" @click="doBack" ><span class="icons-center material-icons">keyboard_arrow_left</span>LAST</md-button>
         <md-button class="md-raised custButton "  :disabled="canNext" @click="doNext" >NEXT<span class="icons-center material-icons">keyboard_arrow_right</span></md-button>
         <div class="dropdown">
           <md-button class="md-raised custButton " @click="doDropDown" :disabled="this.needLockLoad()">Add<span class="icons-center material-icons">add</span></md-button>
           <div id="dropdown" class="dropdown-content" v-if="showDropDown">
             <div v-if="!debug">
               <a v-if="showLISel" href="#" id="dd_li" @click="doAddStage('LI')">Add Load In</a>
               <a v-if="showLOSel" href="#" @click="doAddStage('LO')">Add Load Out</a>
               <a v-if="showEISel" href="#" @click="doAddStage('EI')">Add Empty In</a>
               <a v-if="showEOSel" href="#" @click="doAddStage('EO')">Add Empty Out</a>
               <a v-if="showCISel" href="#" @click="doAddStage('CI')">Add Chassis In</a>
               <a v-if="showCOSel" href="#" @click="doAddStage('CO')">Add Chassis Out</a>
               <a v-if="showRSel" href="#" @click="doAddStage('R')">Add Reuse</a>
               <br v-if="showTSel"/>
               <a v-if="showTSel" href="#" @click="doAddStage('T')">Add Transfer</a>
            </div>
            <div v-if="debug">
               <a href="#" id="dd_li" @click="doAddStage('LI')">Add Load In</a>
               <a href="#" @click="doAddStage('LO')">Add Load Out</a>
               <a href="#" @click="doAddStage('EI')">Add Empty In</a>
               <a href="#" @click="doAddStage('EO')">Add Empty Out</a>
               <a href="#" @click="doAddStage('CI')">Add Chassis In</a>
               <a href="#" @click="doAddStage('CO')">Add Chassis Out</a>
               <a href="#" @click="doAddStage('R')">Add Reuse</a>
               <br/>
               <a href="#" @click="doAddStage('T')">Add Transfer</a>
            </div>
           </div> 
         </div>
         <md-button class="confirmbttn2" v-if="canloadconfirm()" @click="doConfirmLoad" v-debounce:click="3000"><span class="icons-center material-icons">lock</span>Confirm Load</md-button> 
         <md-button class="unconfirmbttn2" v-if="canloadunconfirm()" @click="doUnConfirmLoad" v-debounce:click="3000"><span class="icons-center material-icons">lock_open</span>UnConfirm Load</md-button> 
         <!--<md-button class="md-raised custButton " @click="doSendAll" ><span class="icons-center material-icons">send</span>SEND</md-button>-->
      </callingApiCenter>
    </div>
    <!-- Load Info -->
    <div class="setborder">
    <div class="border_label"><label>Load Info</label>
    <md-button
                  class="md-icon-button updownarrow"
                  @click="doHideLoadInfo"
                  id="expand-button"
                >
             <md-icon v-if="!showLoad">keyboard_arrow_down</md-icon>
             <md-icon v-if="showLoad">keyboard_arrow_up</md-icon>
        </md-button>
    </div>
    <div class="r_divider"></div>    
    <div v-if="showLoad">
    <!-- Load info Start -->
    <div class=" md-layout md-gutter md-alignment-center ">
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Load Status</label>
                 <md-input v-model="paramList.loadStatus" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Rev Window</label>
                 <md-input v-model="paramList.receivingWindow" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Load Key</label>
                 <md-input v-model="paramList.loadKey" disabled></md-input>
            </md-field>
      </div>  
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Container#</label>
                 <md-input v-model="paramList.containerNo" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Cont. type</label>
                 <md-input v-model="paramList.ctnrType" disabled></md-input>
            </md-field>
      </div>
    </div>
    <div class=" md-layout md-gutter md-alignment-center ">
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="paramList.chassisNo" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Seal#</label>
                 <md-input v-model="paramList.sealNumber" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Out Gate Date</label>
                 <md-input v-model="paramList.chzStartDate" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>In Gate Date</label>
                 <md-input v-model="paramList.chzEndDate" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Cargo-cut off date</label>
                 <md-input v-model="paramList.cutLFD" disabled></md-input>
            </md-field>
      </div>
    </div>
    <div class=" md-layout md-gutter md-alignment-center ">
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Load Grade</label>
                 <md-input v-model="paramList.grade" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>STC DO</label>
                 <md-input v-model="paramList.deliveryOrder" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Booking</label>
                 <md-input v-model="paramList.bookingNo" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Carrier</label>
                 <md-input v-model="paramList.carrier" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label v-if="chkloadbkgrade()">STC DO Grade</label>
                 <label v-if="!chkloadbkgrade()" style="color:red">STC DO Grade</label>
                 <md-input v-model="paramList.loadBookingGrade" disabled></md-input>
            </md-field>
      </div>
    </div> 
    <div class=" md-layout md-gutter md-alignment-center ">
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Customer Order</label>
                 <md-input v-model="paramList.customerOrder" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>DropOff Tml</label>
                 <md-input v-model="paramList.ctnrDropOff" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Appointment</label>
                 <md-input v-model="paramList.appointment" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Appt. date</label>
                 <md-input v-model="paramList.apptDate" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Appt.Time</label>
                 <md-input v-model="paramList.apptTime" disabled></md-input>
            </md-field>
      </div>
    </div>
    <div class=" md-layout md-gutter md-alignment-center ">
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Customer</label>
                 <md-input v-model="paramList.custId" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Driver Group</label>
                 <md-input v-model="paramList.driverGroup" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Driver</label>
                 <md-input v-model="paramList.driverId" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Push Status</label>
                 <md-input v-model="paramList.pushStatus" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Truck ID</label>
                 <md-input v-model="paramList.truckId" disabled></md-input>
            </md-field>
      </div>
    </div>
    <div class=" md-layout md-gutter md-alignment-center ">
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Dispatcher</label>
                 <md-input v-model="paramList.dispatcher" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label v-if="paramList.specGrade == null || paramList.specGrade == ''">Special Grade/Instruction</label>
                 <label v-if="paramList.specGrade != null && paramList.specGrade != ''" style="color:red">Special Grade/Instruction</label>
                 <md-input v-model="paramList.specGrade" disabled></md-input>
            </md-field>
      </div>
      <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Driver Remark</label>
                 <md-input v-model="paramList.driverRemark" disabled></md-input>
            </md-field>
      </div>
     
    </div>
    <!-- Load info End -->
    </div> 
    </div>   
    <!--  End Load In -->
    <div class="itemlist">
    <div v-for="item in items" :key="item.loadKeyWithStageNo">
      <div class="md-layout md-gutter md-alignment-center ">
           <md-toolbar>
             <h3 class="md-title">{{getStageTypeInfo(item.stageType)}}</h3>
             <md-button class="md-raised custButton " v-if="!item.newitem" @click="doEdit(item)" :disabled="needLockStage(item)" ><span class="icons-center material-icons">create</span>Edit</md-button>
             <md-button
                  class="custButton md-raised"
                  @click="getBookingAssign(item)"
                  v-if="item.editing && isToShowLoadIn(item.stageType)"
                  :disabled="checkIsBookingAssigned(item)"
                  > 
                  Assign BK
              </md-button>
              <md-button
                  class="custButton md-raised"
                  @click="getBookingAssignEmptyOut(item)"
                  v-if="item.editing && isToShowEmptyOut(item.stageType)"
                  :disabled="checkIsBookingAssigned(item)"
                  > 
                  Assign BK
              </md-button>
              <md-button 
                  class="custButton md-raised"
                  @click="getBookingUnAssign(item)"
                  v-if="item.editing && isToShowLoadIn(item.stageType)"
                  :disabled="!checkIsBookingAssigned(item)"
                  > 
                  Un-Assign
                </md-button>
                <md-button 
                  class="custButton md-raised"
                  @click="getBookingUnAssignEmptyOut(item)"
                  v-if="item.editing && isToShowEmptyOut(item.stageType)"
                  :disabled="!checkIsBookingAssigned(item)"
                  > 
                  Un-Assign
                </md-button>
             <!---<md-button class="md-raised custButton " v-if="item.editing" @click="doSave(item)" ><span class="icons-center material-icons">create</span>Save</md-button>-->
             <md-button class="md-raised custButton " v-if="item.editing && !item.newitem" @click="doChkRemoveAndSave(item)" v-debounce:click="5000"><span class="icons-center material-icons">save</span>Save</md-button>
             <md-button class="md-raised custButton " v-if="item.editing && item.newitem" @click="doChkRemoveAndSaveFromNew(item)" v-debounce:click="5000" ><span class="icons-center material-icons">save</span>New</md-button>
             <md-button class="md-raised custButton " v-if="item.editing && !item.newitem" @click="doCancel(item)" ><span class="icons-center material-icons">cancel</span>Cacnel</md-button>
             <!--<md-button class="md-raised custButton " v-if="item.editing" @click="doRemove(item)" ><span class="icons-center material-icons">create</span>Remove</md-button>-->
             <md-button class="md-raised custButton " @click="doSend(item)"  v-debounce:click="5000" :disabled="needLockStage(item)"><span class="icons-center material-icons">send</span>SEND</md-button>

             <md-checkbox v-if="item.editing" v-model="item.remove">Remove</md-checkbox>
             <div class="vl"></div>
             <div style="margin-left: 10px"></div>
             <template v-if="!item.editing">
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')"><span class="icons-center material-icons">assignment_turned_in</span>CTNR</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')"><span class="icons-center material-icons">assignment_turned_in</span>CHASSIS</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')"><span class="icons-center material-icons">assignment_turned_in</span>INTERCHG</md-button>
             </template>
             <template v-else>
                <!--
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')"><span class="icons-center material-icons">assignment_turned_in</span>C</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')"><span class="icons-center material-icons">assignment_turned_in</span>CH</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')"><span class="icons-center material-icons">assignment_turned_in</span>IC</md-button>
                -->
                <div class="dropdown">
                  <md-button class="md-raised custButton" @click="doDropDown2(item)"><span class="icons-center material-icons">assignment_turned_in</span>VERIFY</md-button>
                  <!--
                  <template v-if="toShowDropDown2(item)">
                     <div id="dropdown2" class="dropdown-content2">
                     <a href="#" :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')">Container</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')">Chassis</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')">INTERCHG</a>
                     </div>
                  </template>   
               -->
                  <div id="dropdown2" class="dropdown-content2" v-if="item.showDropDown2">
                     <a href="#" :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')">Container</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')">Chassis</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')">INTERCHG</a>
                  </div>
               </div>
             </template>
             <div style="margin-left: 10px;">
               <!--
               <md-button class="confirmbttn" v-if="canstageconfirm(item)" @click="doConfirmStage(item)" v-debounce:click="3000" :disabled="candisablestageconfirm(item)"><span class="icons-center material-icons">lock</span>Confirm Stage</md-button> 
               <md-button class="unconfirmbttn1" v-if="canstageunconfirm(item)" @click="doUnConfirmStage(item)" v-debounce:click="3000" :disabled="candisablestageunconfirm(item)"><span class="icons-center material-icons">lock_open</span>UnConfirm Stage</md-button> 
               -->
               
               <md-button class="confirmbttn" v-if="canstageconfirm(item)" @click="doConfirmStage(item)"  v-debounce:click="3000"><span class="icons-center material-icons">lock</span>Confirm Stage</md-button> 
               <md-button class="unconfirmbttn1" v-if="canstageunconfirm(item)" @click="doUnConfirmStage(item)"  v-debounce:click="3000"><span class="icons-center material-icons">lock_open</span>UnConfirm Stage</md-button> 
               
               <!--
               <template v-if="!item.editing">  
                  <div class="result-included-outter-div">
                    <div class="result-included-inner-div">
                       Confirm:
                    </div>
                    <div class="result-included-div-span">
                      <span>
                         <md-checkbox v-model="item.ctnrPicConfirmed" disabled>Container</md-checkbox>
                      </span>
                      <span class="result-included-span">
                         <md-checkbox v-model="item.chassisPicConfirmed" disabled>Chassis</md-checkbox>
                      </span>
                      <span class="result-include-span">
                         <md-checkbox v-model="item.interTicketPicConfirmed" disabled>Int Ticket</md-checkbox>
                      </span> 
                    </div>
                 </div>
               </template>
               <template v-else>
                  <div style="margin-left:30px"></div>
                  <div class="result-included-outter-div-s">
                    <div class="result-included-div-span-s">
                      <span>
                         <md-checkbox v-model="item.ctnrPicConfirmed">Cont</md-checkbox>
                      </span>
                      <span class="result-included-span-s">
                         <md-checkbox v-model="item.chassisPicConfirmed">Chassis</md-checkbox>
                      </span>
                      <span class="result-include-span-s">
                         <md-checkbox v-model="item.interTicketPicConfirmed">EIR</md-checkbox>
                      </span> 
                    </div>
                 </div>
               </template>
            -->
             </div>             
             <md-button
                  class="md-icon-button"
                  @click="doHideItem(item)"
                  id="expand-button"
                >
             <md-icon v-if="!item.show">keyboard_arrow_down</md-icon>
             <md-icon v-if="item.show">keyboard_arrow_up</md-icon>
             </md-button>
             <callingApiCenter :paths="['/api/w/gst/WebSearchCockpit' ,
            '/api/w/gst/updateyardstage','/api/w/gst/createyardstage','/api/w/stc/updateDispatchSend','/api/w/DOs/WebUnAssignBooking',
            '/api/w/gst/WebConfirmLoad','/api/w/stc/WebStageAssignBooking','/api/w/stc/WebStageUnAssignBooking']">
            </callingApiCenter>
           </md-toolbar>
      </div>
      <div v-if="item.show && isToShowLoadIn(item.stageType)">
        <div class=" md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <!--
            <template v-if="item.editing">
               <auto-complete-master-data-select
                           group="REC_WINDOW"
                           label="Recv Window"
                           :init-value="item.receivingWindow"
                           :on-item-changed="handleWindowsChanged(item)"
                                       >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
               <md-field>
                 <label>Recv Window</label>
                 <md-input v-model="item.receivingWindow" disabled></md-input>
               </md-field>
            </template>
         -->
               <md-field>
                 <label>Recv Window</label>
                 <md-input v-model="item.receivingWindow" disabled></md-input>
               </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Container#</label>
               <md-input v-model="item.containerNo" disabled></md-input>
            </md-field>
          </div>

          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                 <label v-if="chkloadstagecarrier(item)">Carrier From Load</label>
                 <label v-if="!chkloadstagecarrier(item)" style="color:red">Carrier From Load</label>
                 <md-input v-model="paramList.carrier" disabled></md-input>
               </md-field>
         </div>

          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Cont. type</label>
                <md-input v-model="item.ctnrType" disabled></md-input>
              </md-field>
            </template>
         
         <!--
              <md-field>
                <label>Cont. type</label>
                <md-input v-model="paramList.ctnrType" disabled></md-input>
              </md-field>
            -->    
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Seal#</label>
               <md-input v-model="item.sealNumber" :disabled="!item.editing"></md-input>
            </md-field>
          </div>
       </div>
      
       <div class=" md-layout md-gutter md-alignment-center ">
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                 <label v-if="!chkloadstagegrade(item)" style="color:red">STC DO Grade</label>
                 <label v-if="chkloadstagegrade(item)">STC DO Grade</label>
                 <!--<md-input v-model="paramList.grade" disabled></md-input>-->
                 <md-input v-model="item.bookingGrade" disabled></md-input> 
               </md-field>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="item.chassisNo" disabled></md-input>
              </md-field>
           </div>
           
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                 <datepicker v-model="item.chzStartDate">
                    <label>Out Gate Date</label>
                 </datepicker>
              </template>
              <template v-else>
                 <md-field>
                   <label>Out Gate Date</label>
                   <md-input v-model="item.chzStartDate" disabled></md-input>
                 </md-field>
              </template>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <datepicker v-model="item.chzEndDate">
                    <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">In Gate Date</label>
               </datepicker>
            </template>
            <template v-else>
               <md-field>
                 <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">In Gate Date</label>
                 <md-input v-model="item.chzEndDate" disabled></md-input>
               </md-field>
            </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
         </div>   
       </div>
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Chassis used day</label>
               <md-input v-model="item.chzUseDay" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label v-if="paramList.mismatchBooking != true">Booking</label>
               <label v-if="paramList.mismatchBooking == true" style="color:red;">Booking</label>
               <!--<md-input v-model="item.bookingNo" :disabled="!item.editing"></md-input>-->
               <md-input v-model="item.bookingNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                   <label>Empty Pulled Booking</label>
                   <md-input v-model="paramList.emptyPulledBooking" disabled></md-input>
            </md-field>
         </div>   
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-checkbox v-if="paramList.mismatchBooking != true" v-model="paramList.mismatchBooking" disabled>Mis-match Booking</md-checkbox>
            <md-checkbox v-if="paramList.mismatchBooking == true" v-model="paramList.mismatchBooking" disabled><span style="color:red;">Mis-match Booking</span></md-checkbox>
         </div>   
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-checkbox  :disabled="!item.editing" v-model="item.needChassisAdditionPic">Chassis Photo+</md-checkbox>
         </div>   
      </div>


       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">

            <template v-if="item.editing">
               <auto-complete-master-data-select
                           group="STC_CARRIER"
                           label="DO Carrier"
                           displayType="nameOnly"
                           :init-value="item.carrier"
                           :on-item-changed="handleCarrierChanged(item)"
                           >
              </auto-complete-master-data-select>
            </template>
            <template v-else>
               <md-field>
                 <label v-if="chkloadstagecarrier(item)">DO Carrier</label>
                 <label v-if="!chkloadstagecarrier(item)" style="color:red">DO Carrier</label>
                 <md-input v-model="item.carrier" disabled></md-input>
               </md-field>
            </template>
         </div>

         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Load In Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Load In Cont. type</label>
                <md-input v-model="item.ctnrType" disabled></md-input>
              </md-field>
            </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Cnt Drop-off"
                              :init-value="item.containerDropOffLocation"
                              :on-item-changed="handleCtnrDropOffLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                    <label>Cnt Drop-off</label>
                    <md-input v-model="item.containerDropOffLocation" disabled></md-input>
                  </md-field>
               </template>
         </div>

         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <!--
              <template v-if="item.editing">
                 <datepicker v-model="item.gwDate" >
                    <label>Scale Date</label>
                 </datepicker>
              </template>
              <template v-else>
                 <md-field>
                   <label>Scale Date</label>
                   <md-input v-model="paramList.gwDate" disabled></md-input>
                 </md-field>
              </template>
            -->
               <md-field>
                   <label>Scale Date</label>
                   <md-input v-model="paramList.gwDate" disabled></md-input>
               </md-field>

         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                   <label>Chassis Plus BOL</label>
                   <md-input v-model="item.chassisPlusPhotoBOL" :disabled = !item.editing></md-input>
            </md-field>
         </div>


       </div>   
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appointment</label>
               <md-input v-model="item.appointment" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <template v-if="item.editing">
               <datepicker v-model="item.apptDate" >
                    <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">Appt. Date</label>
               </datepicker>
             </template>
             <template v-else>
               <md-field>
                 <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">Appt. date</label>
                 <md-input v-model="item.apptDate" disabled></md-input>
               </md-field>
             </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appt. time</label>
               <md-input v-model="item.apptTime" :disabled="!item.editing"></md-input>
            </md-field>
         </div>

         <!-- rate type -->
          <!--
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <template v-if="item.editing">
               <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
            </template> 
            <template v-else>
               <md-field>
                 <label>Rate Type</label>
                 <md-input v-model="item.freightType" disabled></md-input>
               </md-field>   
            </template>
          </div>
         -->

         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>

          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
           </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
       </div>
       <div class="  md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Dispatch Instruction</label>
               <md-input v-model="item.dispatcherInstruction" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
       </div>   
       <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>

          <!-- stage status -->
           <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
         -->

          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <template v-if="item.editing">
               <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
            </template> 
            <template v-else>
               <md-field>
                 <label>Rate Type</label>
                 <md-input v-model="item.freightType" disabled></md-input>
               </md-field>   
            </template>
          </div>


          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   
      </div> 
      <div v-if="item.show && isToShowLoadOut(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Pick up terminal"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handlePickupTermChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Pick up terminal</label>
                     <md-input v-model="item.containerPickupLocation" :disabled = !item.editing></md-input>
                  </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Container #</label>
                   <md-input v-model="item.containerNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!--
               <template v-if="item.editing">
                 <auto-complete-master-data-select
                          label="Carrier"
                          group="GST_CARRIER"
                          display-type="nameOnly"
                          :init-value-id="item.carrier"
                          :on-item-changed="handleCarrierChanged(item)">
                </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Carrier</label>
                   <md-input v-model="item.carrier" disabled></md-input>
                 </md-field>
               </template>
            -->
                <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="item.ctnrType" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <template v-if="item.editing">
                  <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
                  </datepicker>
                </template>
                <template v-else>
                  <md-field>
                   <label>Appt. date</label>
                      <md-input v-model="item.apptDate" disabled></md-input>
                   </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                     <label>Rate Type</label>
                     <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                 <md-checkbox  :disabled="!item.editing" v-model="item.needChassisAdditionPic">Chassis Photo+</md-checkbox>
             </div>
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>            
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>BOL#</label>
                   <md-input v-model="item.bolNum" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>PIN #</label>
                   <md-input v-model="item.pinNum" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
               <datepicker v-model="item.chzEndDate">
                    <label>Service Date</label>
               </datepicker>
            </template>
            <template v-else>
               <md-field>
                 <label>Service Date</label>
                 <md-input v-model="item.chzEndDate" disabled></md-input>
               </md-field>
            </template>
            </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Chassis Plus BOL</label>
                   <md-input v-model="item.chassisPlusPhotoBOL" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   
       <div class="  md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Dispatch Instruction</label>
               <md-input v-model="item.dispatcherInstruction" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
       </div>   

      </div>
      <div v-if="item.show && isToShowEmptyIn(item.stageType)">
         <!--  Empty in start -->
         <!-- first session start -->
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Container -->
                <md-field>
                   <label>Container #</label>
                   <md-input v-model="item.containerNo" :disabled = !item.editing></md-input>
                </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Chassis -->
                <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNo" disabled></md-input>
                </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Seal -->
                <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" :disabled = !item.editing></md-input>
                </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Container Type -->
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="paramList.ctnrType" disabled></md-input>
                 </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-checkbox  :disabled="!item.editing" v-model="item.needChassisAdditionPic">Chassis Photo+</md-checkbox>
            </div>
         </div>         
         <!-- first session end -->

         <!-- second session start -->
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Carrier -->
                 <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Pick Up Location -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Cnt Pick Up Location"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handleCtnrPickupLocChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                    <label>Cnt Pick Up Location</label>
                    <md-input v-model="item.containerPickupLocation" :disabled = !item.editing></md-input>
                  </md-field>
                </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Drop Off Location -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Cnt Drop Off Location"
                              :init-value="item.containerDropOffLocation"
                              :on-item-changed="handleCtnrDropOffLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Cnt Drop Off Location</label>
                   <md-input v-model="item.containerDropOffLocation" :disabled = !item.editing></md-input>
                </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Chassis Vendor -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                  </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis Plus BOL</label>
                   <md-input v-model="item.chassisPlusPhotoBOL" :disabled = !item.editing></md-input>
                </md-field>
            </div>
         </div>         
         <!-- second session end -->

         <!-- third session start -->
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- out gate date -->
               <template v-if="item.editing">
                 <datepicker v-model="item.chzStartDate">
                    <label>Out Gate Date</label>
                 </datepicker>
               </template>
               <template v-else>
                 <md-field>
                   <label>Out Gate Date</label>
                   <md-input v-model="item.chzStartDate" disabled></md-input>
                 </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- in gate date -->
               <template v-if="item.editing">
                  <datepicker v-model="item.chzEndDate">
                    <label>In Gate Date</label>
                  </datepicker>
               </template>

               <template v-else>
                 <md-field>
                   <label>In Gate Date</label>
                   <md-input v-model="item.chzEndDate" disabled></md-input>
                 </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Chassis used day -->
               <md-field>
                   <label>Chassis used day</label>
                   <md-input v-model="item.chzUseDay" :disabled="!item.editing"></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Rate Type -->
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            </div>
         </div>         
         <!-- third session end -->

         <!-- forth session start -->
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Appointment -->
               <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Appointment Date -->
               <template v-if="item.editing">
                  <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
                  </datepicker>
               </template>
               <template v-else>
                  <md-field>
                    <label>Appt. date</label>
                    <md-input v-model="item.apptDate" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Appointment Time -->
               <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            </div>
         </div>         
         <!-- forth session end -->

         <!-- fifth session start -->
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Driver -->
               <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Seq# -->
               <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Stage Status -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                         >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Cost Rel -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            </div>
         </div>         
         <!-- fifth session end -->

         <!-- sixth session start -->
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <!-- Dispatch Instruction -->
                  <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatcherInstruction" :disabled = !item.editing></md-input>
                  </md-field>
            </div>
         </div>         
         <!-- sixth session end -->
         

<!--  Empty in end -->
      </div>
      <div v-if="item.show && isToShowEmptyOut(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                  <label>Container#</label>
                  <md-input v-model="item.emptyoutContainerNo" :disabled="!item.editing"></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="item.emptyoutChassisNo" :disabled="!item.editing"></md-input>
              </md-field>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                <auto-complete-master-data-select
                           group="STC_CARRIER"
                           label="Carrier"
                           displayType="nameOnly"
                           :init-value="item.carrier"
                           :on-item-changed="handleCarrierChanged(item)"
                           >
                </auto-complete-master-data-select>
              </template>
              <template v-else>
                <md-field>
                  <label>Carrier</label>
                  <md-input v-model="item.carrier" disabled></md-input>
                </md-field>
              </template>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <!-- service date -->
               <template v-if="item.editing">
                  <datepicker v-model="item.chzEndDate">
                    <label>Service Date</label>
                  </datepicker>
               </template>
               <template v-else>
                  <md-field>
                    <label>Service Date</label>
                    <md-input v-model="item.chzEndDate" disabled></md-input>
                  </md-field>
               </template>
           </div>  
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-checkbox  :disabled="!item.editing" v-model="item.needChassisAdditionPic">Chassis Photo+</md-checkbox>
           </div>  
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Booking</label>
                   <md-input v-model="item.stageBookingNo" disabled></md-input>
                </md-field>
             </div>
             <!--
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                 <md-field>
                    <label>Empty Pulled Booking</label>
                    <md-input v-model="item.emptyPulledBooking" disabled></md-input>
                 </md-field> 
             </div>
            -->
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                 <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="item.ctnrType" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Cnt Pick Up Location"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handleCtnrPickupLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Cnt Pick Up Location</label>
                   <md-input v-model="item.containerPickupLocation" :disabled = !item.editing></md-input>
                </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <!-- Drop off Loc -->   
                <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Cnt Drop Off Location"
                              :init-value="item.containerDropOffLocation"
                              :on-item-changed="handleCtnrDropOffLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Cnt Drop Off Location</label>
                   <md-input v-model="item.containerDropOffLocation" :disabled = !item.editing></md-input>
                </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis Plus BOL</label>
                   <md-input v-model="item.chassisPlusPhotoBOL" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div>       
         <div class="md-layout md-gutter md-alignment-center">
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
                  </datepicker>
               </template>
               <template v-else>
                 <md-field>
                   <label>Appt. date</label>
                   <md-input v-model="item.apptDate" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatcher</label>
                   <md-input v-model="item.dispatcher" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>               
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
         </div>
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   
       <div class="  md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Dispatch Instruction</label>
               <md-input v-model="item.dispatcherInstruction" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
       </div>   
       
      </div>

      <div v-if="item.show && (isToShowChassisIn(item.stageType) || isToShowChassisOut(item.stageType))">
         <!-- chassis in and out start --> 
         <!-- first session -->
         <div class="  md-layout md-gutter md-alignment-center ">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- chassis# -->
               <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNo" disabled></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- chassis size -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Chassis size"
                              :init-value="item.chassisSize"
                              :on-item-changed="handleChassisSizeChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Chassis size</label>
                     <md-input v-model="item.chassisSize" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- chassis vendor -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Chassis Vendor</label>
                    <md-input v-model="item.chassisVendor" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- service date-->
               <template v-if="item.editing">
                 <datepicker v-model="item.chzEndDate">
                    <label>Service Date</label>
                 </datepicker>
               </template>
               <template v-else>
                 <md-field>
                   <label>Service Date</label>
                   <md-input v-model="item.chzEndDate" disabled></md-input>
                 </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            </div>
         </div>
         <!-- second session -->
         <div class="  md-layout md-gutter md-alignment-center ">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- chassis pickup loc -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              label="Chassis pickup location"
                              :prepared-options="getMasterDataAsSelectOptionByGroup('STC_TERMINAL')"
                              :init-value="item.chassisPickupLocation"
                              :on-item-changed="handleChassisPickupLocChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Chassis pickup location</label>
                     <md-input v-model="item.chassisPickupLocation" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- chassis drop off loc -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Chassis dropoff location"
                              :init-value="item.chassisDropOffLocation"
                              :on-item-changed="handleChassisDropOffLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                     <label>Chassis dropoff location</label>
                     <md-input v-model="item.chassisDropOffLocation" disabled></md-input>
                 </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- rate type -->
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-checkbox  :disabled="!item.editing" v-model="item.needChassisAdditionPic">Chassis Photo+</md-checkbox>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis Plus BOL</label>
                   <md-input v-model="item.chassisPlusPhotoBOL" :disabled = !item.editing></md-input>
                </md-field>
            </div>
         </div>
         <!-- third session -->
         <div class="  md-layout md-gutter md-alignment-center ">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- Driver -->
               <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- seq# -->
               <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- stage status -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Stage Status</label>
                     <md-input v-model="item.stageStatus" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- cost rel -->
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
                  </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Cost Rel</label>
                     <md-input v-model="item.costRelevant" disabled></md-input>
                  </md-field>
               </template>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            </div>
         </div>
         <!-- forth session -->
         <div class="  md-layout md-gutter md-alignment-center ">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
               <!-- Dispatch Inst -->
               <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatcherInstruction" :disabled = !item.editing></md-input>
               </md-field>
            </div>
         </div>
            

       <!-- Chassis in and oout end -->
      </div>
      <div v-if="item.show && ( isToShowReuse(item.stageType) || isToShowTransfer(item.stageType) )">
         <div class="  md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Pick up location"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handleCtnrPickupLocChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Pick up location</label>
                   <md-input v-model="item.containerPickupLocation" disabled></md-input>
                </md-field>
             </template>     
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Drop off location"
                              :init-value="item.containerDropOffLocation"
                              :on-item-changed="handleCtnrDropOffLocChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Drop off location</label>
                   <md-input v-model="item.containerDropOffLocation" disabled></md-input>
                </md-field>
             </template>     
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Container#/Trailer#</label>
                   <md-input v-model="paramList.containerNo" disabled></md-input>
            </md-field>
          </div>  
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-checkbox  :disabled="!item.editing" v-model="item.needChassisAdditionPic">Chassis Photo+</md-checkbox>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                   <label>Chassis Plus BOL</label>
                   <md-input v-model="item.chassisPlusPhotoBOL" :disabled = !item.editing></md-input>
               </md-field>
          </div>    
         </div>    
         <div class="  md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Chassis #</label>
                   <md-input v-model="paramList.chassisNo" disabled></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" disabled></md-input>
            </md-field>
          </div>
          <div v-if="isToShowReuse(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                 <datepicker v-model="item.chzStartDate">
                    <label>Out Gate Date</label>
                 </datepicker>
              </template>
              <template v-else>
                 <md-field>
                   <label>Out Gate Date</label>
                   <md-input v-model="item.chzStartDate" disabled></md-input>
                 </md-field>
              </template>
           </div>
           <div v-if="isToShowReuse(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <datepicker v-model="item.chzEndDate">
                    <label>In Gate Date</label>
               </datepicker>
            </template>
            <template v-else>
               <md-field>
                 <label>In Gate Date</label>
                 <md-input v-model="item.chzEndDate" disabled></md-input>
               </md-field>
            </template>
         </div>
         <div v-if="isToShowReuse(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                   <label>Chassis used day</label>
                   <md-input v-model="item.chzUseDay" :disabled="!item.editing"></md-input>
               </md-field>
         </div>   
         <div v-if="isToShowTransfer(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <datepicker v-model="item.chzEndDate">
                    <label>Service Date</label>
               </datepicker>
            </template>
            <template v-else>
               <md-field>
                 <label>Service Date</label>
                 <md-input v-model="item.chzEndDate" disabled></md-input>
               </md-field>
            </template>
         </div>   
         <div v-if="isToShowTransfer(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
         </div>   
         <div v-if="isToShowTransfer(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
         </div>   
      </div>
      <div class="md-layout md-gutter md-alignment-center">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <md-field>
               <label>Appointment#</label>
               <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
             </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <template v-if="item.editing">
               <datepicker v-model="item.apptDate" >
                  <label>Appt. Date</label>
               </datepicker>
             </template>
             <template v-else>
               <md-field>
                  <label>Appt. date</label>
                  <md-input v-model="item.apptDate" disabled></md-input>
               </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <md-field>
                <label>Appt. time</label>
                <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
             </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                <label>BOL #</label>
                <md-input v-model="paramList.bolNum" disabled></md-input>
             </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
          </div>
      </div>      

      <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>
       <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatcherInstruction" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
    </div>
      
      
    </div>

    </div>


  
    <!--<md-button class="md-raised custButton " @click="doNew"><span class="icons-center material-icons">create</span>Add Stages</md-button>-->
    <!--
    <md-button class="md-raised custLongButton " @click="doNew"><span class="icons-center material-icons">add</span>Add Load Out</md-button>
    <md-button class="md-raised custLongButton " @click="doNewOutGate"><span class="icons-center material-icons">add</span>Add Empty In</md-button>
    <md-button class="md-raised custLongButton " @click="doNewTransfer"><span class="icons-center material-icons">add</span>Add Empty Out</md-button>
    <md-button class="md-raised custLongButton " @click="doNewChassisOut"><span class="icons-center material-icons">add</span>Add Chassis In</md-button>
    <md-button class="md-raised custLongButton " @click="doNewChassisOut"><span class="icons-center material-icons">add</span>Add Chassis Out</md-button>
    <md-button class="md-raised custLongButton " @click="doNewChassisOut"><span class="icons-center material-icons">add</span>Add Transfer</md-button>
    -->
    <br/><br/><br/>
    </div>

</template>
<style scoped>
.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover, .dropbtn:focus {
  background-color: #2980B9;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  /*display: none;*/
  /*position: absolute;*/
  /*position: relative;*/
  position: fixed;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  z-index: 100;
}
.dropdown-content2 {
  /*display: none;*/
  /*position: absolute;*/
  /*position: relative;*/
  position: fixed;
  background-color: #f1f1f1;
  min-width: 130px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  z-index: -1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content2 a {
  color: black;
  padding: 12px 12px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}

.itemlist {
   margin-left: -100px;
}
.setborder {
   border-radius: 25px;
   border: 2px solid #73AD21;
   /*background-position: left top;*/
   /*background-repeat: repeat;*/
   padding: 20px;
   width: 1300px;
   height: 100%;
   margin-bottom: 20px;
   margin-left: -100px;
}

.border_label {
   width: 200px;
   background-color: #20B2AA;
   padding: 5px;
   border: 2px solid #20B2AA;
   border-top-left-radius: 5px;
   border-top-right-radius: 5px;
   height: 35px;
}
.border_label label {
   margin-left: 10px;
   color: white;
   font-weight: bold;

}

.r_divider {
   border-top: 8px solid #bbb;
   /*border-radius: 5px;*/
   border-top-right-radius: 5px;
   border-bottom-right-radius: 5px;
}

.updownarrow {
   margin-left: 50px;
   margin-top: -10px;
   position: fixed;
}

.vl {
   margin-left: 10px;
   border-left: 6px solid gray;
   height: 50px;
}

.result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 420px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-outter-div-s {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 280px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 2px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 80px; 
    margin-top: 5px;
}
.result-included-span {
    margin-left: 5px;
}
.result-included-div-span-s {
    margin-left: 8px; 
    margin-top: 5px;
}
.result-included-span-s {
    margin-left: 5px;
}

.unconfirmbttn {
  padding: 0 6px 0 6px;
  margin: 6px 8px 6px 8px;
  min-width: 88px;
  border-radius: 3px;
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  text-decoration:none;
  border: none;
  outline: none;   
}

.unconfirmbttn1 {
  color : white;
  background-color: rgba(235, 84, 109, 0.96);
  border-radius: 0 10px 10px 0;
  font-size: 16px;
}

.unconfirmbttn2 {
  color : white;
  background-color: rgba(235, 84, 109, 0.96);
  border-radius: 5px 5px 5px 5px;
  font-size: 16px;
}

.confirmbttn {
  color : white;
  background-color: rgba(109, 148, 233, 0.96);
  border-radius: 0 10px 10px 0;
  font-size: 16px;
}

.confirmbttn2 {
  color : white;
  background-color: rgba(109, 148, 233, 0.96);
  border-radius: 5px 5px 5px 5px;
  font-size: 16px;
}

.notmatchcolor {
   color: red !important;
}
</style>

<script>

/* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api/index.js';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import OutboundBooking from '../components/OutboundBooking.vue';
  import StageOutboundBooking from '../components/StageOutboundBooking.vue';
  import { GlobalAccelerator } from '@aws-sdk/client-global-accelerator';


const initList = () => ({
  mode : null,
  carrier: null,
  loadKey: null,
  route: null,
  deliveryOrder: null,
  ctnrType: null,
  cutLFD: null,
  loadStatus: null,
  customerOrder: null,
  containerNo: null,
  chassisNo: null,
  chassisVendor: null,
  appointment: null,
  apptDate: null,
  apptTime: null,
  salesOffice: null,
  seqNo: null,
  bookingNo: null,
  receivingWindow: null,
  pushStatus: null,
  chzEndDate: null,
  chzStartDate: null,
  chzUseDay: null,
  inYardDate: null,
  dispatcher: null,
  sealNumber: null,
  driverGroup: null,
  driverId: null,
  driverRemark: null,
  custId: null,
  usedDay: null,
  grade: null,
  specGrade: null,
  loadBookingGrade: null,
  bookingGrade: null,
  ctnrPickup: null,
  ctnrDropOff: null,
  gwDate: null,
  bolNum: null,
  doProcess: null,
  emptyoutContainerNo: null,
  emptyoutChassisNo: null,
  emptyPulledBooking: null,
  mismatchBooking: null,
  handler: null,
});

const initInOutTransSave = () => ({
  bookingNo: null,
  stageStatus: null,
  stage: null,
  costRel: null,
  freightType: null,
  driverId: null,
  carrier: null,
  ctnrType: null,
  cntPickUp: null,
  cntDropOff: null,
  appointment: null,
  truckId: null,
  containerNo: null,
  chassisNo: null,
  dispatcher: null,
  apptDate: null,
  apptTime: null,
  dispatchInst: null,
})

const initChzOutSave = () => ({
   stageStatus: null,
   stage: null,
   ctnrType: null,
})

const initDispatchLoadSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    inGateDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
})

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
})

const initLoadAsgBk = () => ({
     ctnrType: null,
     grade: null,
     carrier: null 
})

const initLoadUnAsgBk = () => ({
     deliveryOrder: null,
     bookObl: null,
     ibs: null,
     seqNo: null
})

const initUpdateSend = () => ({
     seqNo: null,
     stages: [],
})

const initPicGet = () => ({
     containerSeqNo: null
})

const initbackupItem = () => ({
     loadStatus: null,
     stageStatus: null,
     containerNo: null,
     chassisNo: null,
     carrier: null,
     moveInDate: null,
     chzStartDate: null,
     chzEndDate: null,
     chzUseDay: null,
     deliveryOrder: null,
     stageTypeWithStatus: null,
     apptDate: null,
     apptTime: null,
     appointment: null,
     pickupDate: null,
     driverId: null,
     truckId: null,
     costRelevant: null,
     freightType: null,
     pickupLocationCode: null,
     pickUpLocationName: null,
     deliverLocationCode: null,
     deliverLocationName: null,
     dispatcherInstruction: null,
     containerPickupLocation: null,
     containerDropOffLocation: null,
     offsiteScale: null,
     ccicDropOffLocationCode: null,
     bookingNo: null,
     stageBookingNo: null,
     customerOrder: null,
     ctnrtype: null,
     cutLFD: null,
     pickupLoc: null,
     deliveryTo: null,
     grade: null,
     specGrade: null,
     loadBookingGrade: null,
     bookingGrade: null,
     weight: null,
     sealNumber: null,
     pickupTerm: null,
     dropOffTerm: null,
     bolNum: null,
     inYardDate: null,
     chassisVendor: null,
     chassisPickupLocation: null,
     chassisDropOffLocation: null,
     chassisPickupTerm: null,
     chassisDropOffTerm: null,
     chassisSize: null,
     inGateDate: null,
     emptyoutContainerNo: null,
     emptyoutChassisNo: null,
     custID: null,
     newLoadKey: null,
     dropoffTermLocDes: null,
     pickupTermLocDes: null
})

const initDummyContainerInfo = () => ({
     containerNo: null,
     chassisNo: null,
     salesOffice: null,
     source: null,
     transloadingYard: null,
     receivingWindows: null,
     cntrType: null,
     carrier: null,
     moveInDate: null,
     moveInBy: null,
     loadStatus: null,
     yard: null,
     loadIndicator: null,
     bobtailContainer: null,
     action: null,
})

const initDriverSMS = () => ({
     seqNo: null,
     loadKeyWithStageNo: null,
     containerNo: null,
     stageType: null,
     loadIndictator: null,
     driverId: null,
     driverCompany: null,
     driverMobile: null,
     message: null,
     sendFrom: null      
})

export default {

    data: () => ({
     paramList: initList(), 

     saveInOutTrans: initInOutTransSave(),
     saveChzOut: initChzOutSave(),
     dispatchLoadSearch: initDispatchLoadSearch(),
     searchDriverReq: getInitDriverSearch(),
     loadAsgBkInfo: initLoadAsgBk(),
     loadUnAsgBkInfo: initLoadUnAsgBk(),
     reqUpdateSend: initUpdateSend(),
     reqPicGet: initPicGet(),
     backupItem: initbackupItem(),
     driverSMS: initDriverSMS(),
     dummyContainer: initDummyContainerInfo(),
     photos: [],
     loadList: [],
     params: null,
     pointer: null,
     items: null,
     loginuser: null,
     drivers: [],
     driverIds: [],
     driverNames: [],
     driverContent: [],
     driverContact: [],
     dispRateCostList: [],
     dispRateCostCodes: [],
     stageTypeList: [],
     terminals: [],
     driverSMSReq: [],
     indicator: false,
     showInOutTrans: true,
     showChzOut: false,
     defaultDisabled: true,
     itemCount: null,
     driverId: null,
     carrier: null,
     disableAsgBk: true,
     disableUnAsgBk: true,
     showDropDown: false,
     showDropDown2: false,
     loadHide: false,
     isLoadIn: false,
     isLoadOut: false,
     isEmptyOut: false,
     isEmptyIn: false,
     isChassisIn: false,
     isChassisOut: false,
     isTransfer: false,
     isReuse: false,
     loadEdit: false,
     disableLoadAsgBk: true,
     disableLoadUnAsgBk: true,
     show: true,
     showLoad: true,
     showLISel: false,
     showEISel: false,
     showEOSel: false,
     showCISel: false,
     showCOSel: false,
     showTSel: false,
     showRSel: false,
     hideLoadInfo: false,
     showconfirm: true,
     debug: false,
     isfromsearch: false,
     disableconfirmload: false,
     disableunconfirmload: false,
     disableconfirmstage: false,
     disableunconfirmstage: false,
     matchloadgrade: true,
     matchstagegrade: true,
    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
      OutboundBooking,
      StageOutboundBooking,
    },

    watch: {
       clonedItems: {
         handler: function(after, before) {
            if (before) {
            //console.log("watch chzenddate: after: " + JSON.stringify(after[0].chzEndDate) + ", before: " + JSON.stringify(before[0].chzEndDate));
            //after.forEach((it) => {
            //console.log("after length: " + after.length);   
            for (let i = 0; i < after.length; i++) {  
               //console.log("i: " + i);  
               if (before) {
                  //console.log("checking before chz dates" + before[i].chzStartDate + ", " + after[i].chzStartDate);
                  if (after && after[i].chzStartDate) {
                     if (before[i].chzEndDate != after[i].chzEndDate 
                         || before[i].chzStartDate != after[i].chzStartDate) {
                           //console.log('process recal chassis used day');
                         //console.log("need recal chzstartdate before: " + before[i].chzStartDate 
                         //        + ", after: " + after[i].chzStartDate
                         //        + ", chzenddate before: " + before[i].chzEndDate
                         //        + ", after: " + after[i].chzEndDate
                         //        );
                          //if (after[i].chzStartDate > after[i].chzEndDate) {
                          //   alert("Out Gate Date is greater than In Gate Date!");
                          //   return;
                          //}
                          //if (!this.isfromsearch) {
                             var t_chzuseday = this.getChassisUsedDate(after[i]).toString();
                             //console.log("chzuseday after cal: " + t_chzuseday);
                             if (t_chzuseday != "NaN")       
                                this.items[i].chzUseDay = t_chzuseday;  
                             else
                                this.items[i].chzUseDay = "-1";        
                          //} else {
                          //   this.isfromsearch = false;
                          //}  
                     }        
                  }
               }
            //})
            }
           }
         },
         deep: true
       } 
    },

    computed: {
        ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getGSTDriverMaster',
        'getBillRateByCategory'
      ]),

      clonedItems: function() {
         return JSON.parse(JSON.stringify(this.items))
      },

      canLast(){
        //return this.pointer == 0;
        //console.log("canLast: " + this.pointer + " loadList length: " + this.loadList.length);
        if (this.pointer > 0 && this.loadList && this.loadList.length > 1) {
        //this.pointer == 0;
           //console.log("return canlast false");
           return false;
        }   
        else {
           //console.log("return canlast true");
           return true;
        }      
      },


      canNext(){
         //console.log("canNext: " + this.pointer + " , " + this.loadList + " loadList length: " + this.loadList.length);
         if (this.loadList && (this.pointer <  this.loadList.length - 1)) {
             //console.log("return canNext false");
             return false; //endable button
         }    
         else {
             //console.log("return canNext true");
             return true;  //disable button
         }        
      //   if (this.loadList && this.loadList.length >= 1){
      //      //return this.pointer == this.loadList.length - 1;
      //      this.pointer == this.loadList.length - 1;
      //      console.log("do next: " + this.pointer);
      //      return false;
      //   }   
      //   else
      //   {
      //      //return 0; 
      //      console.log("can't do next: " + this.pointer);
      //      return true;  
      //   }  
      },

      // getAssignBookingCond(item) {
      //    if (item.bookingNo == null || item.bookingNo == "") 
      //        return false; 
      //    else return true;
      // },

      // getUnAssignBookingCond() { 
      //    // console.log("unassign cond");
      //    // const item = _(this.items).filter((it) => it.selected);
      //    // const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      //    // if (sapStatus.length == 0) return false
      //    // console.log("unassign item length:" + item.length);
      //    // return item.length === 1 && item[0].loadStatus == 'ASN'
      //    return false;
      // },



    },

    


    async mounted() {
        
       this.searchDriverReq.driverOffice = "STC";
       this.searchDriverReq.defaultSalesOffice = "LGB";
       this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
       this.updateDrivers(this.getGSTDriverMaster);
       //console.log("drivers from getter: " + this.drivers);
       this.getSTCTerminal();
       //var dispRateCost = JSON.parse(JSON.stringify(this.getBillRateByCategory("DRIVER"))); 
       var dispRateCost = this.getBillRateByCategory("DRIVER"); 
       //console.log("dispRateCost: " + JSON.stringify(dispRateCost));
       if (dispRateCost) {
          dispRateCost.forEach( (it) => {
             this.dispRateCostCodes.push(it.tagId);
             this.dispRateCostList.push(it.tagName + "(" + it.tagId + ")");
             //console.log("dispRateCost item: " + it.tagId + ", name: " + it.tagName);
          })
       } 
        //console.log("name: " + this.$route.name);
        //console.log("route params: " + JSON.parse(this.$route.params.req));
        //console.log("route params: " + JSON.parse(this.$route.params.req));
        //console.log("route params1: " + this.$route.params.req);
        //console.log("route params2: " + this.$route.params.searchCriteria);

        this.loadList = JSON.parse(this.$route.params.req);
        var searchCriteria = JSON.parse(this.$route.params.searchCriteria);
        //console.log("containerNo: " + searchCriteria.containerNo);
        this.dispatchLoadSearch.containerNo = searchCriteria.containerNo;
        this.dispatchLoadSearch.receivingWindow = searchCriteria.receivingWindow;
        this.dispatchLoadSearch.salesOffice = searchCriteria.salesOffice;
        this.dispatchLoadSearch.pickUpLocation = searchCriteria.pickUpLocation;
        this.dispatchLoadSearch.bookingNo = searchCriteria.bookingNo;
        this.dispatchLoadSearch.destination = searchCriteria.destination;
        this.dispatchLoadSearch.appointment = searchCriteria.appointment;
        this.dispatchLoadSearch.driveId = searchCriteria.driverId;
        this.dispatchLoadSearch.driverGroup = searchCriteria.driverGroup;
        this.dispatchLoadSearch.costRelevant = searchCriteria.costRelevant;
        this.dispatchLoadSearch.freightType = searchCriteria.freightType;
        this.dispatchLoadSearch.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
        this.dispatchLoadSearch.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
        this.dispatchLoadSearch.apptDate.startDate = searchCriteria.apptDate.startDate;
        this.dispatchLoadSearch.apptDate.endDate = searchCriteria.apptDate.endDate;
        this.dispatchLoadSearch.loadKey = searchCriteria.loadKey;
        this.dispatchLoadSearch.source = searchCriteria.source;
        this.dispatchLoadSearch.chassisNo = searchCriteria.chassisNo;
        this.dispatchLoadSearch.carrier = searchCriteria.carrier;
        this.dispatchLoadSearch.customerOrder = searchCriteria.customerOrder;
        this.dispatchLoadSearch.deliveryOrder = searchCriteria.deliveryOrder;
        this.dispatchLoadSearch.loadStatus = searchCriteria.loadStatus;
        this.dispatchLoadSearch.pushStatus = searchCriteria.pushStatus;
        this.dispatchLoadSearch.stageType = searchCriteria.stageType;
        this.dispatchLoadSearch.filter = searchCriteria.filter;
        this.dispatchLoadSearch.fromPage = searchCriteria.fromPage;
        this.dispatchLoadSearch.selectDType = searchCriteria.selectDType;
        this.dispatchLoadSearch.moveInDate.startDate = searchCriteria.moveInDate.startDate;
        this.dispatchLoadSearch.moveInDate.endDate = searchCriteria.moveInDate.endDate;
        this.dispatchLoadSearch.inGateDate.startDate = searchCriteria.inGateDate.startDate;
        this.dispatchLoadSearch.inGateDate.endDate = searchCriteria.inGateDate.endDate;
        //console.log("loadList: " + this.loadList[0].mode);
        //console.log("loadList length: " + this.loadList.length);
        this.pointer = 0;
        if (this.loadList) {
           this.params = this.loadList[0];
           if (this.params) {
             //console.log("loading paramList keys");
             //if (this.params.seqNo == "C000013119")
                //console.log("paramList doProcess: " + this.params.doProcess + ", stageCount: " + this.params.stageCount);
             this.paramList.mode = this.params.mode;
             this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
             this.paramList.loadKey = this.params.loadKey;
             this.paramList.route = this.params.route;
             this.paramList.deliveryOrder = this.params.deliveryOrder;
             this.paramList.ctnrType = this.getDisplay("CCR_CNTRTYPE",this.params.ctnrType);
             //this.paramList.ctnrType = this.params.ctnrType;
             this.paramList.cutLFD = this.params.cutLFD;
             this.paramList.loadStatus = this.params.loadStatus;
             this.paramList.customerOrder = this.params.customerOrder;
             this.paramList.containerNo = this.params.containerNo;
             this.paramList.chassisNo = this.params.chassisNo;
             this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
             this.paramList.appointment = this.params.appointment;
             //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
             this.paramList.apptDate = this.getDate(this.params.apptDate);
             this.paramList.apptTime = this.params.apptTime;
             this.paramList.salesOffice = this.params.salesOffice;
             this.paramList.seqNo = this.params.seqNo;
             this.paramList.bookingNo = this.params.bookingNo;
             this.paramList.receivingWindow = this.params.receivingWindow;
             this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
             //this.paramList.ctnrType = this.params.ctnrType;
             this.paramList.chzEndDate = this.convertDateForDatePicker(this.params.chzEndDate);
             this.paramList.chzStartDate = this.convertDateForDatePicker(this.params.chzStartDate);
             this.paramList.dispatcher = this.params.createdBy;
             this.paramList.sealNumber = this.params.sealNumber;
             this.paramList.driverGroup = this.params.driverGroup;
             this.paramList.driverId = this.params.driverId;
             this.paramList.custId = this.params.custID;
             this.paramList.usedDay = this.getChassisUsedDate(this.params);
             this.paramList.inYardDate = this.params.inYardDate;
             this.paramList.grade = this.params.grade;
             this.paramList.specGrade = this.params.specGrade;
             this.paramList.loadBookingGrade = this.params.loadBookingGrade;
             //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
             //this.paramList.ctnrPickup = this.params.containerPickupLocation;
             this.paramList.ctnrDropOff = this.params.dropOffTerm;
             this.paramList.ctnrPickup = this.params.pickupTerm;
             this.paramList.gwDate = this.getDate(this.params.gwDate);
             this.paramList.bolNum = this.params.bolNum;
             this.paramList.doProcess = this.params.doProcess;
             this.paramList.emptyoutContainerNo = this.params.emptyoutContainerNo;
             this.paramList.emptyoutChassisNo = this.params.emptyoutChassisNo;
             this.paramList.emptyPulledBooking = this.params.emptyPulledBooking;
             this.paramList.mismatchBooking = this.params.mismatchBooking;
             this.paramList.handler = this.params.handler;
           }
           this.pointer = 0;
           //console.log("paramList: " + this.paramList);
        }
      this.checkStageTypeListOpt(this.paramList.mode);  
      //   this.drivers = null;
      //   this.$store.dispatch('getUsersByCategory', { category: 'L' })
      //     .then((res) => {
      //       this.drivers = res;
      //   });
      this.getpic(this.paramList.seqNo);
        await this.doSearch().then( () => {
            //console.log("mounted: after search: items: " + JSON.stringify(this.items));
            if (!this.items || this.items.length < 1) {
               //console.log("items length: " + this.items.length); 
               //if (this.items.length < 1) {
               if (this.paramList.mode == "YY") {
                  //console.log("call doAddStage");
                  if (this.paramList.handler == "BOBTAILEMPTY")
                  {
                     this.doAddStage("EO");
                  } else {
                     this.doAddStage("LI");
                  }
                  //console.log("dd_li: " + document.getElementById("dd_li"));
                  //if (this.items)
                    //console.log("mounted: after doAddStage items length: " + this.items.length + " items[0] show: " + this.items[0].show);
               } else if (this.paramList.mode == "YI") {
                  //console.log("set YI with mode: " + this.paramList.mode);
                  this.doAddStage("LO");
                  //this.doAddStage("CO");
                  //this.doAddStage("LI");
               }
               //else {
               //   console.log("no mode match in mount: " + this.paramList.mode);
               //}
            }
        })

        this.loginuser = this.getUserProfile.username;
        //console.log("login user: " + this.loginuser);
      if (this.paramList.grade != this.paramList.loadBookingGrade) {
         this.matchloadgrade = false;
      } else {
         this.matchloadgrade = true;  
      }
      this.matchstagegrade = true;  

    },
    methods: {
        doAction(){

            //this.$router.go(-1);
            var request = this.dispatchLoadSearch;
            //console.log("req: " + JSON.stringify(request));
            if (request.fromPage == "L" ) {
               this.$router.push({  
                  name: "Load" , 
                  params: { req: JSON.stringify(request) }})
            }
            else {
               this.$router.push({  
                 name: "Stage" , 
                 params: { searchCriteria: JSON.stringify(request) }})
            }
        },

        async doBack(){
          
          this.pointer = this.pointer - 1;
          this.params = this.loadList[this.pointer];
          if (this.params) {
             //console.log("loading paramList keys");
            //  this.paramList.mode = this.params.mode;
            //  this.paramList.carrierName = this.params.carrierName;
            //  this.paramList.loadKey = this.params.loadKey;
            //  this.paramList.route = this.params.route;
            //  this.paramList.deliveryOrder = this.params.deliveryOrder;
            //  this.paramList.ctnrType = this.params.ctnrType;
            //  this.paramList.cutLFD = this.params.cutLFD;
            //  this.paramList.loadStatus = this.params.loadStatus;
            //  this.paramList.customerOrder = this.params.customerOrder;
            //  this.paramList.containerNo = this.params.containerNo;
            //  this.paramList.chassisNo = this.params.chassisNo;
            //  this.paramList.appointment = this.params.appointment;
            //  this.paramList.salesOffice = this.params.salesOffice;
            //  this.paramList.seqNo = this.params.seqNo;
            //  this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.mode = this.params.mode;
            this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
            this.paramList.loadKey = this.params.loadKey;
            this.paramList.route = this.params.route;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.ctnrType = this.getDisplay("CCR_CNTRTYPE",this.params.ctnrType);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.cutLFD = this.params.cutLFD;
            this.paramList.loadStatus = this.params.loadStatus;
            this.paramList.customerOrder = this.params.customerOrder;
            this.paramList.containerNo = this.params.containerNo;
            this.paramList.chassisNo = this.params.chassisNo;
            this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
            this.paramList.appointment = this.params.appointment;
            //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
            this.paramList.apptDate = this.getDate(this.params.apptDate);
            this.paramList.apptTime = this.params.apptTime;
            this.paramList.salesOffice = this.params.salesOffice;
            this.paramList.seqNo = this.params.seqNo;
            this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.receivingWindow = this.params.receivingWindow;
            this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
            this.paramList.chzStartDate = this.getDate(this.params.chzStartDate);
            this.paramList.dispatcher = this.params.createdBy;
            this.paramList.sealNumber = this.params.sealNumber;
            this.paramList.driverGroup = this.params.driverGroup;
            this.paramList.driverId = this.params.driverId;
            this.paramList.custId = this.params.custId;
            this.paramList.usedDay = this.getChassisUsedDate(this.params);
            this.paramList.inYardDate = this.params.inYardDate;
            this.paramList.grade = this.params.grade;
            this.paramList.specGrade = this.params.specGrade;
            this.paramList.loadBookingGrade = this.params.loadBookingGrade;
            //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
            //this.paramList.ctnrPickup = this.params.containerPickupLocation;
            this.paramList.ctnrDropOff = this.params.dropOffTerm;
            this.paramList.ctnrPickup = this.params.pickupTerm;
            this.paramList.gwDate = this.getDate(this.params.gwDate);
            this.paramList.bolNum = this.params.bolNum;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.doProcess = this.params.doProcess;
         }
         this.getpic(this.paramList.seqNo);
          //this.doSearch();
          await this.doSearch().then ( () => {
          if (!this.items || this.items.length < 1) {
               //console.log("items length: " + this.items.length); 
               //if (this.items.length < 1) {
               if (this.paramList.mode == "YY" || this.paramList.mode == "YE") {
                  //console.log("call doAddStage");
                  this.doAddStage("LI");
                  //console.log("dd_li: " + document.getElementById("dd_li"));
                  //if (this.items)
                  //  console.log("mounted: after doAddStage items length: " + this.items.length + " items[0] show: " + this.items[0].show);
               } else if (this.paramList.mode == "YI") {
                  //console.log("set YI with mode: " + this.paramList.mode);
                  this.doAddStage("LO");
                  //this.doAddStage("CO");
                  //this.doAddStage("LI");
               } else if (this.paramList.mode == "YT") {
                  this.doAddStage("T"); 
               } 
               //else {
               //   console.log("no mode match in mount: " + this.paramList.mode);
               //}
            }
         })

        },

        async doNext(){
          //console.log("doNext");
          this.pointer = this.pointer + 1;
          this.params = this.loadList[this.pointer];
          if (this.params) {
             //console.log("loading paramList keys");
            //  this.paramList.mode = this.params.mode;
            //  this.paramList.carrierName = this.params.carrierName;
            //  this.paramList.loadKey = this.params.loadKey;
            //  this.paramList.route = this.params.route;
            //  this.paramList.deliveryOrder = this.params.deliveryOrder;
            //  this.paramList.ctnrType = this.params.ctnrType;
            //  this.paramList.cutLFD = this.params.cutLFD;
            //  this.paramList.loadStatus = this.params.loadStatus;
            //  this.paramList.customerOrder = this.params.customerOrder;
            //  this.paramList.containerNo = this.params.containerNo;
            //  this.paramList.chassisNo = this.params.chassisNo;
            //  this.paramList.appointment = this.params.appointment;
            //  this.paramList.salesOffice = this.params.salesOffice;
            //  this.paramList.seqNo = this.params.seqNo;
            //  this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.mode = this.params.mode;
            this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
            this.paramList.loadKey = this.params.loadKey;
            this.paramList.route = this.params.route;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.ctnrType = this.getDisplay("CCR_CNTRTYPE",this.params.ctnrType);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.cutLFD = this.params.cutLFD;
            this.paramList.loadStatus = this.params.loadStatus;
            this.paramList.customerOrder = this.params.customerOrder;
            this.paramList.containerNo = this.params.containerNo;
            this.paramList.chassisNo = this.params.chassisNo;
            this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
            this.paramList.appointment = this.params.appointment;
            //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
            this.paramList.apptDate = this.getDate(this.params.apptDate);
            this.paramList.apptTime = this.params.apptTime;
            this.paramList.salesOffice = this.params.salesOffice;
            this.paramList.seqNo = this.params.seqNo;
            this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.receivingWindow = this.params.receivingWindow;
            this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
            this.paramList.chzStartDate = this.getDate(this.params.chzStartDate);
            this.paramList.dispatcher = this.params.createdBy;
            this.paramList.sealNumber = this.params.sealNumber;
            this.paramList.driverGroup = this.params.driverGroup;
            this.paramList.driverId = this.params.driverId;
            this.paramList.driverRemark = this.params.driverRemark;
            this.paramList.custId = this.params.custId;
            this.paramList.usedDay = this.getChassisUsedDate(this.params);
            this.paramList.inYardDate = this.params.inYardDate;
            this.paramList.grade = this.params.grade;
            this.paramList.specGrade = this.params.specGrade;
            this.paramList.loadBookingGrade = this.params.loadBookingGrade;
            //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
            //this.paramList.ctnrPickup = this.params.containerPickupLocation;
            this.paramList.ctnrDropOff = this.params.dropOffTerm;
            this.paramList.ctnrPickup = this.params.pickupTerm;
            this.paramList.gwDate = this.getDate(this.params.gwDate);
            this.paramList.bolNum = this.params.bolNum;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.doProcess = this.params.doProcess;
          }
          this.getpic(this.paramList.seqNo);
          await this.doSearch().then ( () => {
          if (!this.items || this.items.length < 1) {
               //console.log("items length: " + this.items.length); 
               //if (this.items.length < 1) {
               if (this.paramList.mode == "YY" || this.paramList.mode == "YE") {
                  //console.log("call doAddStage");
                  this.doAddStage("LI");
                  //console.log("dd_li: " + document.getElementById("dd_li"));
                  //if (this.items)
                  //  console.log("mounted: after doAddStage items length: " + this.items.length + " items[0] show: " + this.items[0].show);
               } else if (this.paramList.mode == "YI") {
                  //console.log("set YI with mode: " + this.paramList.mode);
                  this.doAddStage("LO");
               } else if (this.paramList.mode == "YT") {
                  this.doAddStage("T"); 
               } 
               //else {
               //   console.log("no mode match in mount: " + this.paramList.mode);
               //}
            }
         })
        },

        doAddStage(stageType) {
           // this.showInOutTrans = true;
           // this.showChzOut = false;
           //initial stage type check
           var defaultCostRel = "";
           var defaultFreightType = "";
           var defaultStage = "";
           var group = "STC_LOAD_STAGES_" + this.paramList.mode;
           //console.log("add stage group: " + group); 
           const defaultVal = this.getMasterDataByGroup(group).filter(it => it.tagId === stageType);
           //const defaultVal = this.getMasterDataByGroup(group);
           //console.log("load stage: " + JSON.stringify(defaultVal[2]));
           //console.log("load stage: " + JSON.stringify(defaultVal));
           if (defaultVal && defaultVal.length >= 0) {
              defaultCostRel = defaultVal[0].from;
              defaultFreightType = defaultVal[0].chassisVendorType;
           }
           //console.log("defaultcostrel: " + defaultCostRel + " , defaultfreighttype" + defaultFreightType);

           //console.log("doAddStage: " + stageType);
           this.isEmptyIn = false;
           this.isEmptyOut = false;
           this.isLoadIn = false;
           this.isChassisIn = false;
           this.isChassisOut = false;
           this.isTransfer = false;
           this.isLoadOut = false;
           if (stageType == "EO") {
               this.isEmptyOut = true;
               //console.log("isEmptyOut: " + this.isEmptyOut);
           }    
           if (stageType == "EI") {
               this.isEmptyIn = true;
               //console.log("isEmptyIn: " + this.isEmptyIn);
           }    
           if (stageType == "CI") {
               this.isChassisIn = true;
               //console.log("isChassisIn: " + this.isChassisIn);
           }    
           if (stageType == "CO") {
               this.isChassisOut = true;
               //console.log("isChassisOut: " + this.isChassisOut);
           }    
           if (stageType == "T") {
               this.isTransfer = true;
               //console.log("isTransfer: " + this.isTransfer);
           }    
           if (stageType == "LO") {
               this.isLoadOut = true;
               //console.log("isLoadOut: " + this.isLoadOut);
           }    
           if (stageType == "LI") {
               this.isLoadIn = true;
               //console.log("isLoadIn: " + this.isLoadIn);
           }    
           if (stageType == "R") {
               this.isReuse = true;
               //console.log("isReuse: " + this.isReuse);
           }
           if (this.paramList.bookingNo != null && this.paramList.bookingNo != "")
           {
              this.disableAsgBk = true;
              this.disableUnAsgBk = false;
           }
           else {
              this.disableAsgBk = false;
              this.disableUnAsgBk = true; 
           }
            //this.disableAsgBk = false;
            this.showDropDown = false;
            this.showDropDown2 = false;
            var setStage = "";
            if (this.items) {
               this.itemCount = this.items.length;
               setStage = (this.items.length + 1).toString() + "0";
            } else {
               this.itemCount = 1;
               setStage = "10";
            }

            var loadAppt = null;
            var loadApptDate = null;
            var loadApptTime = null;
            var loadDriverId = null;
            var p_containerNo = this.paramList.containerNo;
            var p_chassisNo = this.paramList.chassisNo;
            if (stageType == "LI") {
               loadAppt = this.params.appointment;
               loadApptDate = this.params.apptDate;
               loadApptTime = this.params.apptTime;
               if (this.params.driverId && this.params.driverId != "")
                  loadDriverId = this.getdriverFromUsername(this.params.driverId);
            }
            var itemBk = this.paramList.bookingNo;
            if (stageType == "EO") {
                itemBk = null; 
                p_containerNo = this.paramList.emptyoutContainerNo;
                p_chassisNo = this.paramList.emptyoutChassisNo;
            }
            var p_chzEndDate = this.paramList.chzEndDate;
            if (this.paramList.chzEndDate == null || this.paramList.chzEndDate == "") {
               p_chzEndDate = dateFormat.date(new Date());
            }
            //console.log("do new - seq: " + this.itemCount + " setStage: " + setStage);
            if (!this.items) this.items = [];
            this.items.push({
            receivingWindow: this.paramList.receivingWindow,   
            stage: setStage,  
            salesOffice: this.paramList.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            //appointment: null,
            //apptDate: null,
            //apptTime: null,
            appointment: loadAppt,
            apptDate: loadApptDate,
            apptTime: loadApptTime,
            driverId: loadDriverId,
            truckId: null,
            costRelevant: (defaultCostRel && defaultCostRel != "")? this.getCostRelFromCode("Y"): null,
            freightType: (defaultFreightType && defaultFreightType != "")? this.getRateCostFromCode(defaultFreightType): null,
            dispatcherInstruction: null,
            containerPickupLocation: this.paramList.ctnrPickup,
            containerDropOffLocation: this.paramList.ctnrDropOff,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            seqNo: this.paramList.seqNo,
            user: "GST_SYSTEM",
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.paramList.deliveryOrder,
            //stageType: "I",
            stageType: stageType,
            bookingNo: this.paramList.bookingNo,
            //containerNo: this.paramList.containerNo,
            containerNo: p_containerNo,
            ctnrType: this.paramList.ctnrType,
            bolNum: this.paramList.bolNum,
            grade: this.paramList.grade,
            bookingGrade: this.paramList.loadBookingGrade,
            sealNumber: this.paramList.sealNumber,
            //chassisNo: this.paramList.chassisNo,
            chassisNo: p_chassisNo,
            chassisVendor: this.paramList.chassisVendor,
            inYardDate: this.paramList.inYardDate,
            //chzEndDate: this.paramList.chzEndDate,
            chzEndDate: p_chzEndDate,
            chzStartDate: this.paramList.chzStartDate,
            chzUseDay: this.getChassisUsedDate(this.paramList),
            gwDate: this.paramList.gwDate,
            //inGateDate: this.paramList.chzEndDate,
            inGateDate: dateFormat.date(new Date()),
            dispatcher: this.loginuser,
            carrier: this.getContentFromBrace(this.paramList.carrier),

            editing : true,
            remove: false,
            newitem: true,
            show: true,
            disableconfirmstage: false,
            disableunconfirmsstage: false,
            });

        },

        doNew(){

            //var stageTypeInName = this.getStageTypeInfo(type);
            this.showInOutTrans = true;
            this.showChzOut = false;
            this.disableAsgBk = false;
            this.itemCount = this.items.length;
            var setStage = (this.items.length + 1).toString() + "0";
            //console.log("do new - seq: " + this.itemCount + " setStage: " + setStage);
            this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "I",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true,
            disableconfirmstage: false,
            disableunconfirmsstage: false,
            });
        },
 
        doNewOutGate() {
          this.showInOutTrans = true;
          this.showChzOut = false;
          this.disableAsgBk = false;
          var setStage = (this.items.length + 1).toString() + "0";
          //console.log("donewoutgate - seq: " + this.itemCount + " setStage: " + setStage);
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "O",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true,
            disableconfirmstage: false,
            disableunconfirmsstage: false,
            });

        },
        doNewTransfer() {
          this.showInOutTrans = true;
          this.showChzOut = false;
          this.disableAsgBk = false;
          var setStage = (this.items.length + 1).toString() + "0";
          //console.log("donewtransfer - seq: " + this.itemCount + " setStage: " + setStage);
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "T",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true,
            disableconfirmstage: false,
            disableunconfirmsstage: false,
            });

        },
        doNewChassisOut() {
          this.showChzOut = true;
          this.showInOutTrans = false;
          this.disableAsgBk = true;
          var setStage = (this.items.length + 1).toString() + "0";
          //console.log("donewchassisout - seq: " + this.itemCount + " setStage: " + setStage);
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "CO",
            stageBookingNo: null,
            editing : true,
            remove: false,
            newitem: true,
            disableconfirmstage: false,
            disableunconfirmsstage: false,
            });

        },

        doLoadEdit() {
            this.loadEdit = true;
            this.disableLoadAsgBk = false;
            if (this.paramList.bookingNo == null || this.paramList.bookingNo == "")
               this.disableLoadUnAsgBk = true;
            else
               this.disableLoadUnAsgBk = false;   
        },

        doLoadCancel() {
            this.loadEdit = false;
            this.disableLoadAsgBk = true;
            this.disableLoadUnAsgBk = true;
        },

        doLoadSave() {

        },


      chkdisablephoto_v(item, type) {
         var mylinks = [];
         var filterVal = item.stageType;
         var filterVal1 = item.stageType;
         var chassisPhotoURLPattern = /CHA[A-Za-z]_C[0-9]{9}_[1-9]0/ig;
         var ctnrPhotoURLPattern = /CTN[A-Za-z]_C[0-9]{9}_[1-9]0/ig;
         var itPhotoURLPattern = /IC[A-Za-z]_C[0-9]{9}_[1-9]0/ig;
         if (type == "C") {
            filterVal += "CTNB" + "_" + item.loadKeyWithStageNo;
            filterVal1 += "CTNS" + "_" + item.loadKeyWithStageNo;
         }   
         if (type == "CH") {  
            filterVal += "CHAB" + "_" + item.loadKeyWithStageNo;
            filterVal1 += "CHAS" + "_" + item.loadKeyWithStageNo;
         }   
         if (type == "IC")   
            filterVal += "IC" + "_" + item.loadKeyWithStageNo;
         //console.log("filterVal: " + filterVal);
         //console.log("photos before process: " + JSON.stringify(this.photos));
         if (type == "C" || type == "CH")
            mylinks = this.photos.filter( it => it.photoKey === filterVal || it.photoKey === filterVal1); 
         if (type == "IC")   
            mylinks = this.photos.filter( it => it.photoKey === filterVal); 
         if (mylinks.length > 0) {
            //console.log("mylink item: " + mylinks[0]);
            //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
            if (mylinks[0].photoUrl != null && mylinks[0].photoUrl != "")
               return false;
         }
         //console.log("this photos: " + JSON.stringify(this.photos));
         //console.log("Matches: " + JSON.stringify(chassisPhotoURLPattern.exec(this.photos)));   
         return true;
      },   
      
      chkloadstagegrade(item) {
         console.log("item booking: " + item.bookingNo + ", grade: " + item.bookingGrade + ", load grade: " + this.paramList.grade);
         if (item.bookingNo != null && item.bookingNo != "" && item.bookingGrade != this.paramList.grade) {
            return false;
         } else {
            return true;
         }
      },

      chkloadstagecarrier(item) {
         console.log("item booking: " + item.bookingNo + ", carrier: " + item.carrier + ", load carrier: " + this.paramList.carrier);
         if (item.bookingNo != null && item.bookingNo != "" && item.carrier != this.getContentFromBrace(this.paramList.carrier)) {
            return false;
         } else {
            return true;
         }
      },

      chkloadbkgrade() {
         if (this.paramList.bookingNo != null && this.paramList.bookingNo != "" && this.paramList.grade != this.paramList.loadBookingGrade) {
            return false;
         } else {
            return true;
         }
      },

      chkapptequalingate(item) {
         if (item != null)
         {
             const p_ingatedate = dateFormat.gstDateFormat(item.chzEndDate);
             const p_apptdate = dateFormat.gstDateFormat(item.apptDate);
             console.log(`comparing ingate and appt: ingate - ${p_ingatedate} appt: ${p_apptdate}`);
             if (p_ingatedate != null && p_apptdate != null)
             {
                 return p_ingatedate == p_apptdate;
             }
         } else {
            console.log(`comparing ingate and appt but item is null/empty`);
            return false;
         }
      },

      changeChkBoxCntr(item) {
          //console.log("item ctnrPicConfirmed: " + item.ctnrPicConfirmed);
          if (item.ctnrPicConfirmed != null)
             item.ctnrPicConfirmed = !item.ctnrPicConfirmed;
          else
             item.ctnrPicConfirmed = true;   
      },
      changeChkBoxChassis(item) {
          item.chassisPicConfirmed = !item.chassisPicConfirmed;
      },
      changeChkBoxIC(item) {
          item.interTicketPicConfirmed = !item.interTicketPicConfirmed;
      },

      canloadconfirm() {
         //console.log("stagestatus: " + this.getStageStatusCode(item.stageStatus) + ", taskStart: " + item.taskStart + ", taskEnd: " + item.taskEnd);
          console.log("loadStatus: " + this.getStageStatusCode(this.paramList.loadStatus));
          if (this.getStageStatusCode(this.paramList.loadStatus) == 'DCP') 
             return true;
          else return false;
      },

      canloadunconfirm() {
         console.log("mode: " + this.paramList.mode);
         console.log("loadStatus: " + this.getStageStatusCode(this.paramList.loadStatus));
         if (this.paramList.mode == "YI") {
            if (this.getStageStatusCode(this.paramList.loadStatus) == 'CFM') 
                return true;
            else 
                return false;    
         } else {
            if (this.getStageStatusCode(this.paramList.loadStatus) == 'CFM'
                || this.getStageStatusCode(this.paramList.loadStatus) == 'BLC') 
               return true;
            else return false;
         }
      },

      canstageconfirm(item) {
         //console.log("stagestatus: " + this.getStageStatusCode(item.stageStatus) + ", taskStart: " + item.taskStart + ", taskEnd: " + item.taskEnd);
          if (this.getStageStatusCode(item.stageStatus) == 'DCP'
             && item.taskStart && item.taskEnd
          ) return true;
          else return false;
      },

      canstageunconfirm(item) {
         if (item.type == "YI") {
            if (this.getStageStatusCode(item.stageStatus) == 'CFM') 
                return true;
            else 
                return false;    
         } else {
            if (this.getStageStatusCode(item.stageStatus) == 'CFM'
                || this.getStageStatusCode(item.stageStatus) == 'BLC') 
               return true;
            else return false;
         }
      },

      candisablestageconfirm(item)  {
         if (item.disablestageconfirm == true && item.disablestageunconfirm == false)
            return true;
         else
            return false;    
      },

      candisablestageunconfirm(item) {
         if (item.disablestageconfirm == false && item.disablestageunconfirm == true)
            return true;
         else
            return false;   
      },

      toggleItemLink1(item,imgType) {
        var mylink = "";
        var mylinks = [];
        var title = "";
        var width;
        var height;
        var leftPos;
        var topPos;
        var settings = "";
        var userWidth = screen.availWidth;
        var userHeight = screen.availHeight;
        var filterVal = item.stageType;
        var filterVal1 = item.stageType;

        item.showDropDown2 = false;

        width =  400;
        height = 200;
        //leftPos = (userWidth - width) /2;
        //leftPos = 1500;
        leftPos = userWidth - 500;
        topPos = (userHeight - height) /2;
        //console.log("leftPos: " + leftPos + " topPos: " + topPos);
        //console.log("avail height: " + userHeight + " avail width: " + userWidth);
        settings += 'left=' + leftPos + ',top=' + topPos + ',width=' + width + ',height=' + height;
        settings += ',scrollbars=yes';
        //console.log("settings: " + settings);
        if (imgType == "IC") {
             title = "Interchange Ticket";
             //mylink = this.getpic(item,"IC");
             filterVal += "IC" + "_" + item.loadKeyWithStageNo;
             //console.log("filterVal: " + filterVal);
             //console.log("photos before process: " + JSON.stringify(this.photos));
             mylinks = this.photos.filter( it => it.photoKey === filterVal); 
             if (mylinks.length > 0) {
               //console.log("mylink item: " + mylinks[0]);
               //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
               mylink = mylinks[0].photoUrl;
             }
             //console.log("mylink: " + mylink);
        }    
          if (imgType == "C") {
             title = "Container# Image";
             //mylink = this.getpic(item,"C");
             filterVal += "CTNB" + "_" + item.loadKeyWithStageNo;
             filterVal1 += "CTNS" + "_" + item.loadKeyWithStageNo;
             //console.log("filterVal: " + filterVal);
             //console.log("photos before process: " + JSON.stringify(this.photos));
             mylinks = this.photos.filter( it => it.photoKey === filterVal || it.photoKey === filterVal1); 
             //console.log("mylinks length: " + mylinks.length + ", mylinks: " + JSON.stringify(mylinks));
             if (mylinks.length > 0) {
               //console.log("mylink item: " + mylinks[0]);
               //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
               mylink = mylinks[0].photoUrl;
             }
             //console.log("mylink: " + mylink);
          }
          if (imgType == "CH") {
             title = "Chassis# Image";
             filterVal += "CHAB" + "_" + item.loadKeyWithStageNo;
             filterVal1 += "CHAS" + "_" + item.loadKeyWithStageNo;
             //console.log("filterVal: " + filterVal);
             //console.log("photos before process: " + JSON.stringify(this.photos));
             mylinks = this.photos.filter( it => it.photoKey === filterVal || it.photoKey === filterVal1); 
             if (mylinks.length > 0) {
               //console.log("mylink item: " + mylinks[0]);
               //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
               mylink = mylinks[0].photoUrl;
             }
             //console.log("mylink: " + mylink);
          }        
        if (! window.focus)return true;
           var href;
        if (typeof(mylink) == 'string') href=mylink;
        else href=mylink.href; 
        //window.open(href, title, 'width=400,height=200,scrollbars=yes'); 
        //console.log("href: " + href);
        if (href.toString().indexOf('http') < 0) {
           //console.log("index: " + href.toString().indexOf('http'));
           alert("No Picture to verify");
        }   
        else {
          //window.open(href, title, settings,true);
          //var contents = '<img src="' + href + '"></img>';
          //console.log("mylinks length: " + mylinks.length + "mylinks: " + JSON.stringify(mylinks));
          if (mylinks && mylinks.length > 0) {
              var contents = "";
            //   for (var i=0; i < mylinks.length; i++) {
            //      var content = mylinks[i];
            //      console.log("mylinks (item): " + JSON.stringify(content));
            //      contents += '<div>' + content.photoKey + ' ' + content.photoUrl + '</div><img style="height:500px;width:800px" src="' + content.photoUrl + '"></img><div></div>';
            //   }
              mylinks.forEach( (it) => {
                 //console.log("mylinks (item): " + JSON.stringify(it));
                 contents += '<div>' + it.photoKey + ' ' + it.photoUrl + '</div><div style="margin-top:20px;margin-bottom:20px;"><img style="height:800px;width:1000px" src="' + it.photoUrl + '"></img></div>';
              });
          }
          //console.log("contents: " + contents);
          var previewWindow = window.open('','Preview',settings,true);
          previewWindow.document.body.innerHTML = contents;
        }
        return false; 

      },

      async getpic(seqNo) {
         //console.log("photo seqNo: " + seqNo);
         if (seqNo)
         {
            this.reqPicGet.containerSeqNo = seqNo;
            //var filterVal = item.stageType;
            //var retVal = "";
            //await api.post('/api/w/ccic/photo/get', this.reqPicGet).then ( (res) => {
            await newAPIPost('/api/w/ccic/photo/get', this.reqPicGet).then ( (res) => {
               this.photos = res;
               //console.log("photos: " + JSON.stringify(this.photos));
            })
         }
      },
      // async getpic(item,imgtype) {
      //    this.reqPicGet.containerSeqNo = item.seqNo;
      //    var filterVal = item.stageType;
      //    var retVal = "";
      //    await api.post('/api/w/ccic/photo/get', this.reqPicGet).then ( (res) => {
      //         if (imgtype == "C") {
      //            filterVal += "CTN" + "_" + item.loadKeyWithStageNo;
      //            console.log("filterVal: " + filterVal); 
      //            console.log("getpic res: " + JSON.stringify(res));                
      //            retVal = res.filter( it => it.photoKey === filterVal)[0].photoUrl;
      //            console.log("C retVal: " + JSON.stringify(retVal));
      //            return JSON.stringify(retVal);
      //         } else if (imgtype == "CH") {
      //            filterVal += "CHA" + "_" + item.loadKeyWithStageNo;
      //            retVal = res.filter( photoKey == filterVal ).photoUrl;
      //            console.log("CH retVal: " + retVal);
      //            return retVal;
      //         } else if (imgtype == "IC") {
      //            filterVal += "IC" + "_" + item.loadKeyWithStageNo;
      //            retVal = res.filter( photoKey == filterVal ).photoUrl;
      //            console.log("IC retVal: " + retVal);
      //            return retVal;
      //         } else {
      //            return "";
      //         }   
      //       }) 
 
      // },

        async doLoadSend() {
           var unsave = false;
           
           this.reqUpdateSend.seqNo = this.paramList.seqNo;
           //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
           newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
              
           }) 
        },

        async doSend(item) {
           var hasReqField = false;
           const msg_li_eo = "booking, Appt Date, and driver";
           const msg_lo_ei_ru_tf = "Appt Date and driver";
           const msg_ingatedate = " and ingate";
           const msg_ci_co = "driver";
           var msg_head = "Please ensure ";
           var msg_tail = " been assigned, then SAVE before process SEND!!";
           var msg = "";
           var smsMsg = "PLEASE DO NOT REPLY TO THIS MESSAGE: New Task From STC Dispatcher!!";

           console.log("bookingGrade: " + item.bookingGrade + " load grade: " + this.paramList.grade);
           if (item.stageType == "LI") {
              if (item.bookingNo && item.bookingNo != "" && item.bookingGrade != this.paramList.grade) {
                 alert("Grade info in load doesn't match in stage, please check and update before sending info to driver!!");
                 //return;
              }
           }
           if (item.stageType == "LI" || item.stageType == "EO") {
              if ((item.driverId && item.driverId != "") && (item.bookingNo && item.bookingNo != "")
                          && (item.chzEndDate && item.chzEndDate != "") 
                          && (item.apptDate && item.apptDate != "") && !item.newitem) {
                             hasReqField = true;
                          }             
                          else {
                             msg = msg_head + msg_li_eo + msg_ingatedate + msg_tail;     
                          }
           } else if (item.stageType == "LO" || item.stageType == "EI" || item.stageType == "R" || item.stageType == "T") {
              if ((item.driverId && item.driverId != "") && (item.apptDate && item.apptDate != "") 
                  && (item.chzEndDate && item.chzEndDate != "") 
                  && !item.newitem) {
                             hasReqField = true;
                          }             
                          else {
                             msg = msg_head + msg_lo_ei_ru_tf + msg_ingatedate + msg_tail;     
                          }
            
           } else if (item.stageType == "CI" || item.stageType == "CO") {
              if ((item.driverId && item.driverId != "") 
                  && (item.chzEndDate && item.chzEndDate != "") 
                  && !item.newitem) {
                             hasReqField = true;
                          }             
                          else {
                             msg = msg_head + msg_ci_co + msg_ingatedate + msg_tail;     
                          }
            
           } else { msg = "No such stage type!!"}


           var phonenumregex = /1[1-9][0-9]{9}/;
           var driverUserName = this.getContentFromBrace(item.driverId);
           var driverphonenum = "";
           var cansendSMS = false;
           console.log("driver User Name: " + driverUserName);
           if (driverUserName != null && driverUserName != "") {
               //var driverphonenum = this.getdriverMobileFromUsername(driverUserName);
               var prd_url = document.location.href;
               console.log("prd_url: " + prd_url);
               driverphonenum = this.getdriverMobileFromUsername(driverUserName);
               this.driverSMSReq = [];
               if (driverphonenum != null && phonenumregex.test(driverphonenum)) {
                  console.log("driverphonenum: " + driverphonenum);
                  this.driverSMS.driverMobile = driverphonenum;
                  this.driverSMS.message = smsMsg;
                  this.driverSMS.sendFrom = "STC";
                  this.driverSMS.seqNo = item.seqNo;
                  this.driverSMS.loadKeyWithStageNo = item.loadKeyWithStageNo;
                  this.driverSMS.containerNo = item.containerNo;
                  this.driverSMS.stageType = item.stageType;
                  this.driverSMS.loadIndictator = item.loadIndictator;
                  this.driverSMS.driverId = item.driverId;
                  this.driverSMS.driverCompany = item.driverCompany;
                  this.driverSMSReq.push(this.driverSMS);
                  cansendSMS = true;
               } else { 
                  console.log("driverphonenum is null or format invalid: " + driverphonenum)
               }
           }
           
           if (hasReqField) {
             this.reqUpdateSend.stages.push(item.loadKeyWithStageNo);
             //console.log("send stages: " + JSON.stringify(this.reqUpdateSend.stages));
             console.log("driverSMSReq len: " + this.driverSMSReq.length);
             //await api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
             await newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
                    alert("Stage status updated to 'Dispatched'");
                    if (driverphonenum && driverphonenum != "" && cansendSMS
                          && (item.stageType == "LI" || item.stageType == "LO"
                             || item.stageType == "EI" || item.stageType == "T"
                             || item.stageType == "CI" || item.stageType == "CO")) { 
                       //api.post('/api/w/SendSMS/STCSend', {sendInfo: this.driverSMSReq}).then( (res) => {
                       newAPIPost('/api/w/SendSMS/STCSend', {sendInfo: this.driverSMSReq}).then( (res) => {
                          console.log("Send SMS to Driver ok from stageType: " + item.stageType);  
                       });
                    }
                    this.doSearch();
                    //this.doChkRemoveAndSave(item);
             }) 
           } else {
             alert(msg);
           }

        },


        async doSendAll() {
           var nodriver = false;
           var hasnewitem = false;
           this.reqUpdateSend.seqNo = this.paramList.seqNo;
           this.reqUpdateSend.stages = [];
           this.items.forEach( (it) => {
             if (it.driverId == null || it.driverId == "") {nodriver = true;}
             if (it.newitem) {hasnewitem = true;}
             if (it.loadKeyWithStageNo) {
                var foundObj = this.reqUpdateSend.stages.filter( it => it === it.loadKeyWithStageNo );
                //console.log("foundObj: " + foundObj.length)
                if (foundObj.length == 0)
                   this.reqUpdateSend.stages.push(it.loadKeyWithStageNo); 
             }   
           }) 
           if (!nodriver && !hasnewitem) {
             //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ((res) => {
             newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ((res) => {
               alert("Load and Stage status updated to 'Dispatched'");
               this.doSearch();
               //this.items.forEach( (it) => {
               //   this.doChkRemoveAndSave(it);
               //})
             })
           } else {
             //if (nodriver)
                alert("Please Save any NEW stage and assign driver in all stages before process SEND ALL!!");
             //if (hasnewitem)
             //   alert("Found NEW stage, please Save before SEND!");   
           }   
        },

      //   changeAsgDriverId(isLoad) {
      //      console.log("asg driver is for : " + isLoad);
      //      //return (id, name, unit, weight, plate, trail) => {
      //      return (driver) => {  
      //        this.paramList.driverId = driver;
      //        console.log("load driver Id in item: " + this.paramList.driverId);
      //      };
      //   },
        changeAsgDriverId(item) {
           return (driver) => {
               item.driverId = driver;
               //item.stageStatus = "ASG";
               //this.handleStageStatusChanged(item);
               //console.log("Asg driver Id: " + item.driverId)
           }
        },

        getLoadBookingAssign() {
         var loads = [];
         this.loadAsgBkInfo.grade = this.paramList.grade;
         this.loadAsgBkInfo.ctnrType = this.paramList.ctnrType;
         this.loadAsgBkInfo.carrier = this.paramList.carrier;
         loads.push(this.loadAsgBkInfo);
         if (this.paramList.mode == "YY")
            this.$refs.OutboundBooking.openDialog(loads);
         if (this.paramList.mode == "YI")
            this.$refs.OutboundBookingYI.openDialog(loads);
         if (this.paramList.mode == "YT")
            this.$refs.OutboundBookingYT.openDialog(loads);
         if (this.paramList.mode == "YE")
            this.$refs.OutboundBookingYE.openDialog(loads);          
        },

        getLoadBookingUnAssign() {
         if (!window.confirm('Unassign the Load In booking?')) {
           return;
         }
        
         //const load = this.getSelectedItems
         //var loads = [];
         //this.loadUnAsgBkInfo.deliveryOrder = this.paramList.deliveryOrder;
         //this.loadUnAsgBkInfo.bookObl = this.paramList.bookingNo;
         //this.loadUnAsgBkInfo.ibs = this.paramList.ibs;
         //this.loadUnAsgBkInfo.seqNo = this.paramList.seqNo;
         //loads.push(this.loadUnAsgBkInfo);
         const office = 'LGB'
         //const si = loads[0].deliveryOrder
         //const obk = loads[0].bookObl
         //const ibds = loads[0].ibs
         //const usr = 'GST_SYSTEM'
         //const seqn = loads[0].seqNo
         const si = this.paramList.deliveryOrder;
         const obk = this.paramList.bookingNo;
         const usr = 'GST_SYSTEM';
         const seqn = this.paramList.seqNo;
         //console.log("Set load Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           //ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         //console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(si, obk, 'UASN', seqn);
    
 
         });

        },

        getChassisUsedDate(item){
          console.log("chzStartDate: " + item.chzStartDate + " chzEndDate: " + item.chzEndDate + " chzUseDay: " + item.chzUseDay);
          //if (item && item.chzUseDay == null) {
          if (item) {  
             if (item.chzStartDate != null) {
               if (item.chzEndDate == null)
               {
                 //console.log("getchassisuseddate: chzenddate is null"); 
                 return moment().diff(moment(item.chzStartDate), 'days') + 1;
               }
               else
               {
                  //console.log("getchassisuseddate: chzenddate is not null"); 
                 return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + 1;
               }
            } else {
               //console.log("chzStart is null");
               //alert("Out gate date needs to be filled to get Chassis use day!");
               return 0;
            }
          } else {
             //console.log("item is null") 
             //alert("Chassis use day unable to find without stage info!");
             return 0;
          }
        },

        reGetChassisUsedDate(chzstartdate,chzenddate)
        {
           if (chzstartdate == null && chzenddate == null)
           {
               return 0; 
           } else {
               if (chzstartdate != null) {
                  if (chzenddate == null)
                  {
                     //console.log("getchassisuseddate: chzenddate is null"); 
                     return moment().diff(moment(chzstartdate), 'days') + 1;
                  }
                  else
                  {
                     //console.log("getchassisuseddate: chzenddate is not null"); 
                     return moment(chzenddate).diff(moment(chzstartdate), 'days') + 1;
                  }
               } else {
                  //console.log("chzStart is null");
                  //alert("Out gate date needs to be filled to get Chassis use day!");
                  return 0;
               }
           }
        },

        async updateDrivers(itemsSource) {
          var items = itemsSource;
          if (items && items.length > 0) {  
             items.forEach((it) => {
                var driverInfo = it.shortId + "(" + it.userName + ")";
                this.drivers.push(driverInfo);
                this.driverIds.push(it.driverId);
                this.driverNames.push(it.userName);
                this.driverContent.push(driverInfo);
                this.driverContact.push(it.driverMobile);
             })
          } else {
             //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
             await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            //console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                            this.driverContact.push(it.driverMobile);
                        })
                    }
             });
          }
          //console.log("drivers: [[" + this.drivers + "]]");
          // console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
          // var items = JSON.stringify(itemsSource);
          // var items1 = JSON.parse(items);
          // console.log("update drivers: " + items + ", " + items1);
          // // items.forEach(it => {
             
          // // })
          // console.log("items1 length: " + items1.length);
          // items1.forEach((it) => {
          //    console.log("items: " + JSON.stringify(it.shortId));
          //    var driverinfo = JSON.stringify(it.shortId);
          //    this.drivers.push(driverinfo);
          // })
          // //this.drivers = items;
          // console.log("drivers: " + this.drivers);
          
         //  await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
         //         .then ( (driverinfo) => {
         //            if (driverinfo) {
         //                driverinfo.forEach( (it) => {
         //                    console.log("driver: " + it.shortId);
         //                    this.drivers.push(it.shortId + "(" + it.userName + ")");
         //                    this.driverIds.push(it.driverId);
         //                    this.driverNames.push(it.userName);
         //                    this.driverContent.push(it.shortId + "(" + it.userName + ")");
         //                })
         //            }
         //         });
         //  console.log("drivers: [[" + this.drivers + "]]");
        },

        doEdit(item){
            //console.log(item);

            if (item.stageStatus == 'STC' || item.stageStatus == 'SUC'  )
              {
                alert('The stage has been confirmed or under check, it can not be changed this time!');
                return;
              }
            item.editing = true;
            item.remove = false;
            this.indicator = true;
            //console.log("edit booking: " + item.bookingNo);
            if (item.stageType == "LI" || item.stageType == "EO") {
               if (item.bookingNo != null && item.bookingNo != "") {
                  this.disableAsgBk = true;
                  this.disableUnAsgBk = false;
               }   
               else {
                  this.disableAsgBk = false;  
                  this.disableUnAsgBk = true; 
               }   
            } else {
               this.disableAsgBk = true;
               this.disableUnAsgBk = true; 
            }

            this.saveBackupItem(item);
          
        },

        isManualChassisUseDay(chzstartdate, chzenddate, chzuseday)
        {
            if (this.reGetChassisUsedDate(chzstartdate, chzenddate) != chzuseday)
            {
               return 'X';
            } else {
               return '';
            }
            
        },


        doSave(item)
        {
         //console.log("freight type: " + item.freightType);
          
         if (item.stageType == "LI" && item.chzUseDay && !/^[0-9]+$/.test(item.chzUseDay)) {
            alert("Please only input numeric char for Chassis Use Day!");
            return;
         }
         if (item.stageType == "LI" && item.chzUseDay <=0 || item.chzUseDay > 10) {
            alert("Warning: Chassis use day is less than 0 or greater than 10!");
         }
  //       if (item.chzEndDate < item.chzStartDate) {
        var chzEndDategst = dateFormat.gstDateFormat(item.chzEndDate);
        var chzStartDategst = dateFormat.gstDateFormat(item.chzStartDate);
          if (chzEndDategst < chzStartDategst) {
           // console.log (chzEndDategst);
           // console.log (chzStartDategst);        
            alert("In Gate date is less than Out Gate date, please verify!");
            //return;
         }
         

         var dropofftermloc = item.containerDropOffLocation;
         if (dropofftermloc && dropofftermloc != "") {
            dropofftermloc = this.getMasterDataName('STC_TERMINAL', item.ontainerDropOffLocation);
         }

         var pickuptermloc = item.containerPickupLocation;
         if (pickuptermloc && pickuptermloc != "") {
            pickuptermloc = this.getMasterDataName("STC_TERMINAL", item.containerPickupLocation);
         }
          if (item.loadKeyWithStageNo != null)
          {
            //update
            //console.log("item remove: " + item.remove + ", carrier: " + item.carrier);
            console.log("item containerPickupLocation: " + item.containerPickupLocation + ", containerDropOffLocation: " + item.containerDropOffLocation );
            console.log("dropofftermloc: " + dropofftermloc + ", pickuptermloc: " + pickuptermloc );
            const org_chzuseday = this.getChassisUsedDate(item);
            const chkmanualchzuseday = this.isManualChassisUseDay(this.convertDateForConfirm(item.chzStartDate,"-",false),this.convertDateForConfirm(item.chzEndDate,"-",false),item.chzUseDay);

            if (chkmanualchzuseday == 'X')
            {
                alert(`Warning: Manually overwrite chassis used day to ${item.chzUseDay} (Calculated used day: ${org_chzuseday})`);
            }
            const request = {
            companyOffice : 'GST_' + this.params.salesOffice,
            loadKey : this.params.loadKey, 
            seqNo: this.params.seqNo,
            loadKeyWithStageNo: item.loadKeyWithStageNo,
            stageStatus: this.getStageStatusCode(item.stageStatus),
            appointment: item.appointment,
            apptDate: dateFormat.getLocalDate(item.apptDate),
            apptTime: item.apptTime,
            //driverId: this.driverId,
            driverId: (item.driverId && item.driverId != "")? this.getdriverUserNameFromDriver(item.driverId): item.driverId,
            truckId: item.truckId,
            costRelevant: this.getContentFromBrace(item.costRelevant),
            freightType: this.getRateCostCode(item.freightType),
            chassisVendor: this.getchassisVendorCode(item.chassisVendor),
            dispatcherInstruction: item.dispatcherInstruction,
            containerPickUpLocation: item.containerPickupLocation,
            containerDropOffLocation: item.containerDropOffLocation,
            offsiteScale: item.offsiteScale,
            ccicDropOffLocationCode: item.ccicDropOffLocationCode,
            pickupDate: dateFormat.getLocalDate(item.pickupDate),
            // seqNo: it.loadKey,
            pickupLocationCode: item.pickupLocationCode,
            pickUpLocationName: item.pickUpLocationName,
            deliverLocationCode: item.deliverLocationCode,
            deliverLocationName: item.deliverLocationName,
            stageType: item.stageType,
            deliveryOrder: (item.bookingNo != null && item.bookingNo != "" && item.deliveryOrder == null && this.params.deliveryOrder != null && this.params.deliveryOrder != "" && item.bookingNo == this.params.bookingNo)? this.params.deliveryOrder : item.deliveryOrder,
            //stageType: item.type,
            //bookingNo: item.stageBookingNo,
            bookingNo: item.bookingNo,
            //carrier: this.carrier,
            carrier: item.carrier,
            pinNum: item.pinNum,
            bolNum: item.bolNum,
            //inGateDate: item.inGateDate,
            chzEndDate: this.convertDateForConfirm(item.chzEndDate,"-",true),
            //chzEndDate: this.convertDateForDatePicker(item.chzEndDate),
            chzStartDate: this.convertDateForConfirm(item.chzStartDate,"-",true),
            //chzStartDate: this.convertDateForDatePicker(item.chzStartDate),
            chzUseDay: item.chzUseDay,
            manualchassisuseday: this.isManualChassisUseDay(this.convertDateForConfirm(item.chzStartDate,"-",false),this.convertDateForConfirm(item.chzEndDate,"-",false),item.chzUseDay),
            org_chzuseday: org_chzuseday,
            chassisPickupLocation: item.chassisPickupLocation,
            chassisPickupTerm: item.chassisPickupTerm,
            chassisDropOffLocation: item.chassisDropOffLocation,
            chassisDropOffTerm: item.chassisDropOffTerm,
            chassisSize: this.getChassisSizeCode(item.chassisSize),
            ctnrPicConfirmed: item.ctnrPicConfirmed,
            chassisPicConfirmed: item.chassisPicConfirmed,
            interTicketPicConfirmed: item.interTicketPicConfirmed,
            chassisPlusPhotoBOL: item.chassisPlusPhotoBOL,
            needChassisAdditionPic: item.needChassisAdditionPic,
            dispatcher: item.dispatcher,
            //containerNo: item.containerNo,
            containerNo: this.getActualContainer(item),
            //chassisNo: item.chassisNo,
            chassisNo: this.getActualChassis(item),
            sealNumber: item.sealNumber,
            ctnrType: this.getContentFromBrace(item.ctnrType),
            carrier: item.carrier,
            newLoadKey: item.newLoadKey,
            dropoffTermLocDes: dropofftermloc,
            pickupTermLocDes: pickuptermloc,
            bookingGrade: item.bookingGrade,
            disabled: item.remove
            }
            if (request.stageTypeWithStatus == null) 
            {request.stageTypeWithStatus = this.params.mode}
            request.mode = this.params.mode;
            request.action = 'CHANGE';


          //console.log(request);
         
      
        // await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
         
         //api.post("/api/w/gst/createyardstage", request)
         newAPIPost("/api/w/gst/createyardstage", request)
          .then(() => {
            //this.paramList.chzEndDate = item.chzEndDate;
            //this.paramList.chzStartDate = item.chzStartDate;
            this.$store.commit('clearApiError');
            this.doSearch();
             item.editing = false;
             item.disableconfirmstage = false;
             item.disableunconfirmsstage = false;
             //this.paramList.chzEndDate = item.chzEndDate;
             //this.paramList.chzStartDate = item.chzStartDate;
             //console.log("item info: " + JSON.stringify(item));
             if (item.stageType == "LO" && item.type == "YI" && item.apptDate != null) {
                this.paramList.chzStartDate = item.apptDate; 
             }
          });
          }
          else
          {
            //create
            //console.log("bookingNo: " + item.stageBookingNo + " driverId: " + item.driverId);
            const req = {
            companyOffice : 'GST_' + this.params.salesOffice,
            loadKey : this.params.loadKey || this.params.seqNo,
            stageStatus: this.getStageStatusCode(item.stageStatus),
            appointment: item.appointment,
            apptDate: dateFormat.getLocalDate(item.apptDate),
            apptTime: item.apptTime,
            //driverId: this.driverId,
            driverId: this.getdriverUserNameFromDriver(item.driverId),
            carrier: item.carrier,
            truckId: item.truckId,
            costRelevant: this.getContentFromBrace(item.costRelevant),
            freightType: this.getRateCostCode(item.freightType),
            chassisVendor: this.getchassisVendorCode(item.chassisVendor),
            dispatcherInstruction: item.dispatcherInstruction,
            containerPickUpLocation: item.containerPickupLocation,
            containerDropOffLocation: item.containerDropOffLocation,
            offsiteScale: item.offsiteScale,
            ccicDropOffLocationCode: item.ccicDropOffLocationCode,
            pickupDate: dateFormat.getLocalDate(item.pickupDate),
            // seqNo: it.loadKey,
            pickupLocationCode: item.pickupLocationCode,
            pickUpLocationName: item.pickUpLocationName,
            deliverLocationCode: item.deliverLocationCode,
            deliverLocationName: item.deliverLocationName,
            deliveryOrder: item.deliveryOrder,
            stageType: item.stageType,
            //bookingNo: item.stageBookingNo,
            bookingNo: item.bookingNo,
            pinNum: item.pinNum,
            bolNum: item.bolNum,
            //inGateDate: item.inGateDate,
            chzEndDate: this.convertDateForConfirm(item.chzEndDate,"-",true),
            //chzEndDate: this.convertDateForDatePicker(item.chzEndDate),
            chzStartDate: this.convertDateForConfirm(item.chzStartDate,"-",true),
            //chzStartDate: this.convertDateForDatePicker(item.chzStartDate),
            chzUseDay: item.chzUseDay,
            manualchassisuseday: this.isManualChassisUseDay(this.convertDateForConfirm(item.chzStartDate,"-",false),this.convertDateForConfirm(item.chzEndDate,"-"),item.chzUseDay),
            chassisPickupLocation: item.chassisPickupLocation,
            chassisPickupTerm: item.chassisPickupTerm,
            chassisDropOffLocation: item.chassisDropOffLocation,
            chassisDropOffTerm: item.chassisDropOffTerm,
            chassisSize: this.getChassisSizeCode(item.chassisSize),
            ctnrPicConfirmed: item.ctnrPicConfirmed,
            chassisPicConfirmed: item.chassisPicConfirmed,
            interTicketPicConfirmed: item.interTicketPicConfirmed,
            chassisPlusPhotoBOL: item.chassisPlusPhotoBOL,
            needChassisAdditionPic: item.needChassisAdditionPic,
            dispatcher: this.loginuser,
            containerNo: this.getActualContainer(item),
            chassisNo: this.getActualChassis(item),
            ctnrType: this.getContentFromBrace(item.ctnrType),
            newLoadKey: item.newLoadKey,
            dropoffTermLocDes: dropofftermloc,
            pickupTermLocDes: pickuptermloc,
            disabled: item.remove,
            }
            // if (this.params.mode == "YT")
            // {
            //   req.stageType = "T"
            // }
            // else
            // {
            //   req.stageType = "IN"
            // }
            if (req.stageTypeWithStatus == null) 
            {req.stageTypeWithStatus = this.params.mode}
            req.mode = this.params.mode;
            req.action = 'CREATE';
            //console.log(req);
             //api.post("/api/w/gst/createyardstage", req)
             newAPIPost("/api/w/gst/createyardstage", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
             item.editing = false;
             item.disableconfirmstage = false;
             item.disableunconfirmsstage = false;
             //this.paramList.chzEndDate = item.chzEndDate;
             //this.paramList.chzStartDate = item.chzStartDate;
             if (item.stageType == "LO" && item.type == "YI" && item.apptDate != null) {
                this.paramList.chzStartDate = item.apptDate; 
             }
          });
          }

        },

      getActualContainer(item) {
         if (item.stageType === "EO") 
            return item.emptyoutContainerNo
         else
            return item.containerNo   
      },  

      getActualChassis(item) {
         if (item.stageType === "EO") 
            return item.emptyoutChassisNo
         else
            return item.chassisNo   
      },

      doAddLoadOut() {
           this.showDropDown = false;
      },

      // createBobTailEmptyContainer()
      // {
      //    var chzenddate = new Date().toLocaleDateString('en-CA');
      //    console.log("chzenddate: " + chzenddate);

      // },

      doChkRemoveAndSaveFromNew(item) {
         var index = 0;
         var removeIndx = 0;

         var chzenddate = new Date().toLocaleDateString('en-CA');
         console.log("chzenddate: " + chzenddate);
         
         if (this.paramList.handler == "BOBTAILEMPTY" && (this.params.loadKey == null || this.params.loadKey == ''))
         {
            this.dummyContainer.carrier = this.params.carrier;
            this.dummyContainer.containerNo = this.paramList.containerNo;
            this.dummyContainer.chassisNo = this.paramList.chassisNo;
            this.dummyContainer.salesOffice = "LGB";
            this.dummyContainer.source = "D"; //dummy
            this.dummyContainer.cntrType = "45G0";
            this.dummyContainer.transloadingYard = "1010001";
            this.dummyContainer.sCAC = this.params.carrier;
            this.dummyContainer.moveInDate = chzenddate;
            this.dummyContainer.action = "CREATEDUMMY";
            this.dummyContainer.receivingWindows = this.params.receivingWindow;
            this.dummyContainer.loadStatus = "EPT";
            this.dummyContainer.loadIndicator = this.paramList.mode;
            this.dummyContainer.bobtailContainer = true;
            console.log(`dummycontainer: ${JSON.stringify(this.dummyContainer)}`);
            
            //auto gen the dummy container
            //api.post('/api/w/gst/loadlist/create', this.dummyContainer).
            newAPIPost('/api/w/gst/loadlist/create', this.dummyContainer).
            then((res) => {
                console.log(`res from create dummy: ${JSON.stringify(res)}`);
                this.paramList.loadKey = res.seqNo;
                this.params.seqNo = res.seqNo;
                this.params.loadKey = res.seqNo;
                this.params.salesOffice = "LGB";
                this.paramList.loadStatus = res.loadStatus;
                this.paramList.receivingWindows = res.receivingWindows;
                item.seqNo = res.seqNo;
                console.log(`item: ${JSON.stringify(item)}`);

                if (item.remove == false) {
                   this.doSave(item);
                }
                else {
                   if (item.newitem == true) {
                     removeIndx = this.getItemIndx(index, item.stage);
                     //console.log("indx: " + removeIndx);
                     if (removeIndx > -1)
                        this.items.splice(removeIndx, 1);
                        //console.log("items length after remove: " + this.items.length);
                        //this.items.forEach((it) => {
                        //  console.log("item: " + JSON.stringify(it));
                        //})
                     } else {
                        this.doSave(item);
                     }
                }
            });

         } else {
            console.log(`item: ${JSON.stringify(item)}`);
            if (item.remove == false) {
               this.doSave(item);
            }
            else {
               if (item.newitem == true) {
                  removeIndx = this.getItemIndx(index, item.stage);
                  //console.log("indx: " + removeIndx);
                  if (removeIndx > -1)
                  this.items.splice(removeIndx, 1);
                  //console.log("items length after remove: " + this.items.length);
                  //this.items.forEach((it) => {
                  //  console.log("item: " + JSON.stringify(it));
                  //})
               } else {
                  this.doSave(item);
               }
            }

         }

      },

      doChkRemoveAndSave(item) {
         var index = 0;
         var removeIndx = 0;
         if (item.remove == false) {
            this.doSave(item);
         }
         else {
            if (item.newitem == true) {
               removeIndx = this.getItemIndx(index, item.stage);
               //console.log("indx: " + removeIndx);
               if (removeIndx > -1)
                  this.items.splice(removeIndx, 1);
               //console.log("items length after remove: " + this.items.length);
               //this.items.forEach((it) => {
                //  console.log("item: " + JSON.stringify(it));
               //})
            } else {
               this.doSave(item);
            }
         }
      },

      doHideItem(item) {
         // var itemIndx = 0;
         // var found = false;
         // var searchStage = item.stage;
         // var setVal = false;
         // this.itemToHideStage.forEach( (it) => {
         //    if (it != searchStage && !found) {
         //       itemIndx += 1;
         //    } else {
         //       console.log("itemToHide index: " + itemIndx);
         //       found = true;
         //    }
         // })
         // setVal = !this.itemToHide[itemIndx];
         // console.log("setVal: " + setVal);
         // this.itemToHide[itemIndx] = setVal;
         // //return returnVal;
         item.show = !item.show;
         if (!item.show)
           item.showDropDown2 = false;
      },

      doHideLoadInfo() {
         this.showLoad = !this.showLoad;
      },

      doConfirm() {
         if (this.paramList.loadStatus != "DCP"){
            window.confirm('LoadStatus is not DCP')
            return;
         }
         if (this.paramList.doProcess != "O"){
            window.confirm('DO process is not Open(O)!')
            return;
         }

         const seqNo = this.paramList.seqNo;
         //api
         //   .post("/api/w/gst/WebConfirmLoad", {
         newAPIPost("/api/w/gst/WebConfirmLoad", {
               mode: "loadCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               //billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
               //billingDate: this.paramList.inGateDate,
               billingDate: this.convertDateForConfirm(this.paramList.chzEndDate,"-",false),
               refDoc: seqNo,
               seqNo: seqNo,
               deliveryOrder: this.paramList.deliveryOrder,
               salesOffice: this.paramList.salesOffice
            })
            .then((res) => {
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "CFM";
               this.params.loadStatus = "CFM";
               window.confirm(res);
            });
         this.doSearch();
        
      },

      // doConfirmStage(item) {
      //    console.log("confirm stage")
      //    if (this.getStageStatusCode(item.stageStatus) != "DCP"){
      //       window.confirm('Stage Status is not DCP')
      //       return;
      //    }

      //    if (item.costRelevant == "Cost Relevant(Y)"){
      //      if (item.driverId == "" || item.driverId == null){
      //         window.confirm('Driver information missing!')
      //         return;
      //      }

      //      if (this.getRateCostCode(item.freightType) == "" || this.getRateCostCode(item.freightType) == null){
      //         window.confirm('Freight Type information missing!')
      //         return;
      //      }

           

      //      const seqNo = this.paramList.seqNo;
      //      console.log("confirm stage seqno: " + seqNo);
      //      var deliveryorder = "";
      //      if (item.type == "EO") {
      //          deliveryorder = item.deliveryOrder;
      //      } else {
      //          deliveryorder = this.paramList.deliveryOrder;
      //      }
      //      api.post("/api/w/gst/WebConfirmLoad", {
      //        mode: "stageCFM",
      //        user: "GST_SYSTEM",
      //        username: this.getUserProfile.username,
      //        //billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
      //        //billingDate: item.inGateDate,
      //        billingDate: this.convertDateForConfirm(item.chzEndDate,"-"),
      //        refDoc: item.loadKeyWithStageNo,
      //        seqNo: seqNo,
      //        //deliveryOrder: this.paramList.deliveryOrder,
      //        deliveryOrder: deliveryorder,
      //        salesOffice: this.paramList.salesOffice,
      //        rateType: this.getContentFromBrace(item.freightType),
      //        pf: "DR",
      //        partner: item.driverId
      //      })
      //      .then((res) => {
      //        item.stageStatus = "CFM";
      //        this.showDialog = true;
      //        this.$store.commit("clearApiError");
      //        window.confirm(res);
      //      });
      //      // this.doSearch();
      //    }
      //    console.log("costRelevant: " + item.costRelevant);
      //    //get and use costrel id instead using full string compare
      //    var t_costrel = this.getContentFromBrace(item.costRelevant);
      //    if (t_costrel == 'N' || item.costRelevant == null) {
      //    //if (item.costRelevant == "Cost Relevant(N)" || item.costRelevant == "Cost Relevant()" || item.costRelevant == null ){
      //       console.log("t_costrel: " + t_costrel);  
      //          api.post("/api/w/gst/WebConfirmLoad", {
      //            mode: "stageCMN",
      //            user: "GST_SYSTEM",
      //            username: this.getUserProfile.username,
      //            refDoc: item.loadKeyWithStageNo
      //       })
      //       .then((res) => {
      //          item.stageStatus = "CMN";
      //          this.showDialog = true;
      //          this.$store.commit("clearApiError");
      //          window.confirm(res);
      //       });
      //      // this.doSearch();
      //    }
      //    //}
      // },


      // chkItemToHide(item) {
      //    var itemIndx = 0;
      //    var found = false;
      //    var searchStage = item.stage;
      //    //var setVal = false;
      //    this.itemToHideStage.forEach( (it) => {
      //       if (it != searchStage && !found) {
      //          itemIndx += 1;
      //       } else {
      //          console.log("itemToHide index: " + itemIndx);
      //          found = true;
      //       }
      //    })
      //    //setVal = !this.itemToHide[itemIndx];
      //    console.log("return Val: " + this.itemToHide[itemIndx]);
      //    return this.itemToHide[itemIndx];
      // },

      getItemIndx(indx, stage) {
         var itemindx = indx;
         var found = false;
         //console.log("items length: " + this.items.length);
         //console.log("getitemindex: stage: " + stage);
         this.items.forEach((it) => {
            //console.log("item stage: " + it.stage);
            if (it.stage != stage && !found) {
               itemindx += 1;
            }
            else { 
               //console.log("return in loop" + itemindx );
               //return itemindx;
               found = true;
            }
         }) 
         //console.log("return " + itemindx );
         //console.log("return -1");
         return itemindx;
         //return -1;
      },

      async onstagerefresh(id, ticket, mode, loads,ctnrpickup,ctnrdropoff,scac, ctnrType, grade) {
         //console.log(`${id} , ${ticket} , ${mode}`);
         //console.log("assign booking - DO: " + id + ", BK#: " + ticket + ", item: " + loads);
         var itemlist = [];
         if (loads && loads != "") {
            this.items.forEach( (it) => {
               if (it.vueKey == loads && it.stageType == "EO") {
                  console.log("onstagereferesh item: grade: " + grade);
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  it.containerPickupLocation = ctnrpickup;
                  it.containerDropOffLocation = ctnrdropoff;
                  it.carrier = scac;
                  it.ctnrType = ctnrType;
                  it.bookingGrade = grade;
                  //console.log("onstagerefresh item: " + it);
                  itemlist.push(it);
               }   
            })
            // if (this.items.filter( it => it.vueKey == loads).length > 0) {
            //    console.log("onfresh item: " + JSON.stringify(this.items.filter( it => it.vueKey == loads)));
            //    this.items.filter( it => it.vueKey == loads).bookingNo = ticket;
            // }

         } else { //new
             //console.log("onfresh handle new item")
             this.items.forEach( (it) => {
               if (it.newitem && it.stageType == "EO") {
                  console.log("onstagereferesh item: grade: " + grade);
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  it.containerPickupLocation = ctnrpickup;
                  it.containerDropOffLocation = ctnrdropoff;
                  it.carrier = scac;
                  it.ctnrType = ctnrType;
                  it.bookingGrade = grade;
                  //console.log("onstagerefresh item: " + it);
                  itemlist.push(it);                  
               } 
             })
         }
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         //this.doSearch();
         if (itemlist.length > 0)
            this.doChkRemoveAndSave(itemlist[0]);

      },

      async onrefresh(id, ticket, mode, loads, ctnrpickup,ctnrdropoff,scac, ctnrType, grade) {
         var onfresh_bookingNo = "";
         var onfresh_deliveryorder = "";
         var onfresh_grade = "";
         //console.log(`${id} , ${ticket} , ${mode}`);
         //console.log("assign booking - DO: " + id + ", BK#: " + ticket + ", item: " + loads);
         var itemlist = [];
         console.log("return bk values id: " + id + ", ticket: " + ticket
                     + ", mode: " + mode + ", ctnrpickup: " + ctnrpickup
                     + ", ctnrdropoff: " + ctnrdropoff + ", scac: " + scac
                     + ", ctnrType: " + ctnrType + ", grade: " + grade);
         if (loads && loads != "") {
            this.items.forEach( (it) => {
               if (it.vueKey == loads && it.stageType != "EO") {
                  console.log("onrefresh grade: " + grade);
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  it.containerPickupLocation = ctnrpickup;
                  it.containerDropOffLocation = ctnrdropoff;
                  it.carrier = scac;
                  it.ctnrType = ctnrType;
                  it.bookingGrade = grade;
                  onfresh_bookingNo = ticket;
                  onfresh_deliveryorder = id;
                  onfresh_grade = grade;
                  //console.log("onrefresh item: " + it);
                  itemlist.push(it);
               }   
            })
            // if (this.items.filter( it => it.vueKey == loads).length > 0) {
            //    console.log("onfresh item: " + JSON.stringify(this.items.filter( it => it.vueKey == loads)));
            //    this.items.filter( it => it.vueKey == loads).bookingNo = ticket;
            // }

         } else { //new
             //console.log("onfresh handle new item")
             this.items.forEach( (it) => {
               if (it.newitem && it.stageType != "EO") {
                  console.log("onrefresh grade: " + grade);
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  it.containerPickupLocation = ctnrpickup;
                  it.containerDropOffLocation = ctnrdropoff;
                  it.carrier = scac;
                  it.ctnrType = ctnrType;
                  it.bookingGrade = grade;
                  onfresh_bookingNo = ticket;
                  onfresh_deliveryorder = id;
                  onfresh_grade = grade;
                  //console.log("onrefresh item: " + it);
                  itemlist.push(it);                  
               } 
             })
         }
         this.paramList.bookingNo = onfresh_bookingNo;
         this.paramList.deliveryOrder = onfresh_deliveryorder;
         this.paramList.loadBookingGrade = onfresh_grade;
         if (this.paramList.bookingNo != null && this.paramList.bookingNo != ''
              && this.paramList.emptyPulledBooking != null && this.paramList.emptyPulledBooking != '')
         {
            if (this.paramList.bookingNo != this.paramList.emptyPulledBooking)
            {
               this.paramList.mismatchBooking = true;
            } else {
               this.paramList.mismatchBooking = false;
            } 
         } else {
             this.paramList.mismatchBooking = false;
         }
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         //this.doSearch();
         if (itemlist.length > 0)
            this.doChkRemoveAndSave(itemlist[0]);
       },

      checkIsBookingAssigned(item) {
         //console.log("checkisbookingassigned: " + item.bookingNo);
         if (item.stageType == "EO") {
            if (item.stageBookingNo && item.stageBookingNo != "") 
               return true; 
            else 
               return false;
         } else {   
            if (item.bookingNo && item.bookingNo != "") 
               return true; 
            else 
               return false;
         }   
      }, 

      handleStageStatusChanged(stage) {
        return (id) => {
          stage.stageStatus = id;
        };
      },

      handleGradeChanged(item) {
         return(id) => {
            item.grade = id;
         }
      },

      handleChassisVendorChanged(item) {
         return (id) => {
            item.chassisVendor = id;
         }
      },

      handleCtnrTypeChanged(item) {
         return (id) => {
            item.ctnrType = id;
         } 
      },

      handleWindowsChanged(item) {
         return (id) => {
            item.receivingWindow = id;
         }
      },


      handleDriverChanged() {
         return (id, name, unit, weight, plate, trail) => {
          //console.log("itsm driverPh: " + item.driverPh);
          //item.driverPh = "";
          //console.log(`Item is ${item}`)
          //item.moveInBy = id;
          //item.driverPh = name;
          this.driverId = id;
          //console.log(`Phone is ${item.driverPh}`);
          //item.message = "3555";
          //this.$forceUpdate()
          //console.log("driverId: " + id);
          //console.log("selected Items driverPh: " + item.driverPh);
          //console.log("selected item index: " + item.index);
          //if (item.index > -1)
          //{
          //    console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
          //}
          //if (document.getElementById("smsoutbound"))
          //{
          //   console.log("find smsoutbound element");
          //   document.getElementById("smsoutbound").refresh;
         // }
        };
      },

      handleTruckChanged(item) {
        return (id) => {
          item.truckId = id;
        };
      },
      handleCostRelChanged(item) {
        return (id) => {
          item.costRelevant = id; 
        };
      },
      handleCntrTypeChanged(item) {
        return (id) => {
          item.ctnrType = id;
        }
      },
      handleCtnrPickupLocChanged(item) {
        return (id) => {
          item.containerPickupLocation = id;
        }
      },
      handleCtnrDropOffLocChanged(item) {
         return (id) => {
          item.containerDropOffLocation = id;
        }
      },
      handleFreightTypeChanged(item) {
         return (id) => {
          //console.log("freight type id: " + id);
          item.freightType = id;
         }
          //item.freightType = id;
          //return id;
      },       
      // handleCarrierChanged(name){
      //     console.log('carrier:' + name );
      //     this.carrier = name;
      // },

      handleCarrierChanged(item) {
         return (id, name, unit, weight, plate, trail) => {
            //console.log("handle carrier: " + id + ", " + name);
            item.carrier = id;
         }
      },
      handleRateCost(item) {
         //console.log("rate cost changed." + item.freightType);
         return (cost) => {
            //console.log("rate cost id: " + cost);
            item.freightType = cost;
         }
      },

      handleDropOffChanged(item) {
         return ((id) => {
            item.containerDropOffLocation = id;
         })
      },

      handlePickupTermChanged(item) {
         return ((id) => {
            item.containerPickupLocation = id;
         })
      },

      handleDropoffTermChanged(item) {
         return ((id) => {
            item.containerDropOffLocation = id;
         })
      },
      
      handleChassisPickupLocChanged(item) {
         return ((id) => {
            item.chassisPickupLocation = id;
         })
      },
      handleChassisPickupTermChanged(item) {
         return ((id) => {
            //console.log("chassis pickup term: " + id);
            item.chassisPickupTerm = id;
         })
      },
      handleChassisDropOffLocChanged(item) {
         return ((id) => {
            item.chassisDropOffLocation = id;
         })
      },
      handleChassisDropOffTermChanged(item) {
         return ((id) => {
            item.chassisDropOffTerm = id;
         })
      },
      handleChassisSizeChanged(item) {
         return ((id) => {
            item.chassisSize = id;
         })
      },

      async doConfirmLoad() {
         var cancreate = true;
         if (this.paramList.loadStatus != "DCP"){
            window.confirm('LoadStatus is not DCP')
            return;
         }
         if (this.paramList.doProcess != "O"){
            window.confirm('DO process is not Open(O)!')
            return;
         }
         if (!this.paramList.chzEndDate || this.paramList.chzEndDate == "") {
            window.confirm('In Gate Date is required!')
            return;
         }
         this.disableconfirmload = true;
         const seqNo = this.paramList.seqNo;
         console.log("do confirm load started");

         //await api.post("/api/w/gst/WebSearchCockpit", {seqNo: seqNo})
         await newAPIPost("/api/w/gst/WebSearchCockpit", {seqNo: seqNo})
         .then( (res) => {
           this.$store.commit("clearApiError");
           //console.log("latest load info: " + JSON.stringify(res));
           //console.log("latest load status: " + res[0].loadStatus);
           if (res && res.length > 0) {
              if (res[0].loadStatus != "DCP") {
                 //console.log("load status not equal DCP");
                 this.paramList.loadStatus = res[0].loadStatus
                 cancreate = false;
              }
              else {
                 cancreate = true;
              }
           } else {
              //console.log("can't find the load");
              cancreate = false;
           }
         })
         //console.log("cancreate: " + cancreate);
         if (cancreate == true) {
         //await api
         //   .post("/api/w/apar/create", {
         await newAPIPost("/api/w/apar/create", {
               mode: "loadCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               billingDate: this.convertDateForConfirm(this.paramList.chzEndDate,"-",false),
               refDoc: seqNo,
               seqNo: seqNo,
               deliveryOrder: this.paramList.deliveryOrder,
               salesOffice: this.paramList.salesOffice,
            })
            .then((res) => {
               //console.log("res body:" + res.body + " messages: " + res.messages[0]);
               console.log("res: " + JSON.stringify(res));
               this.showDialog = true;
               this.$store.commit("clearApiError");
               if (this.paramList.mode == "YI") {
                  this.paramList.loadStatus = "CFM";
                  this.params.loadStatus = "CFM";
               }
               else {
                  this.paramList.loadStatus = "BLC";
                  this.params.loadStatus = "BLC";
               }   
               window.confirm(res);
            });
         }
         else
            alert("Load info may not be up-to-date and can't process the confirm, please reload the info and try again!");   
         this.disableunconfirmload = false;   
         this.doSearch();
        
      },

      doUnConfirmLoad() {
         if (this.paramList.mode == "YI") {
            if (this.paramList.loadStatus != "CFM"){
               window.confirm('LoadStatus is not CFM')
               return;
            }
         } else {   
            if (this.paramList.loadStatus != "CFM" && this.paramList.loadStatus != "BLC"){
               window.confirm('LoadStatus is not CFM or BLC')
               return;
            }
         }
         if (this.paramList.doProcess != "O"){
            window.confirm('DO process is not Open(O)!')
            return;
         }
         this.disableunconfirmload = true;
         const seqNo = this.paramList.seqNo;
         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "loadUnCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               refDoc: seqNo
            })
            .then((res) => {
               //console.log("res body:" + res.body + " messages: " + res.messages[0]);
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "DCP";
               this.params.loadStatus = "DCP";
               window.confirm(res);
            });
         this.disableconfirmload = false;   
         this.doSearch();
        
      },

      async doConfirmStage(item) {
         this.disableconfirmstage = true;
         item.disablestageconfirm = true;
         item.disablestageunconfirm = false;
         const seqNo = this.paramList.seqNo;
         var cancreate = true;
         //await api.post("/api/w/gst/WebSearchCockpit", {seqNo: seqNo})
         await newAPIPost("/api/w/gst/WebSearchCockpit", {seqNo: seqNo})
         .then( (res) => {
           //console.log("get latest stage info: " + JSON.stringify(res));
           //console.log("res length: " + res.length);
           for (var resitem in res) {
               console.log("item: " + JSON.stringify(res[resitem]));
               console.log("item loadKeyWithStageNo: " + item.loadKeyWithStageNo + " res item loadkeyWithStageNo: " + res[resitem].loadKeyWithStageNo);
               console.log("in item: " + JSON.stringify(item));
               if (item.loadKeyWithStageNo == res[resitem].loadKeyWithStageNo) {
                   if (res[resitem].stageStatus != "DCP") {
                      cancreate = false;
                      item.stageStatus = res[resitem].stageStatus;
                      alert("Current info may not up-to-date, please reload info!");
                   }
               }
           }
           //console.log("cancreate: " + cancreate);
           //return;

         });
         //cancreate = false;
         //console.log(this.getStageStatusCode(item.stageStatus));

         if (this.getStageStatusCode(item.stageStatus) != "DCP"){
            window.confirm('Stage Status is not DCP')
            return;
         }
         if (cancreate == true) {
            console.log("cancreate: " + cancreate);
         if (item.costRelevant == "Cost Relevant(Y)"){
           if (item.driverId == "" || item.driverId == null){
              window.confirm('Driver information missing!')
              return;
           }

           if (this.getRateCostCode(item.freightType) == " " || this.getRateCostCode(item.freightType) == null){
              window.confirm('Freight Type information missing!')
              return;
           }

           if (!item.chzEndDate || item.chzEndDate == ""){
              window.confirm('In Gate Date is required!')
              return;
           }
           //console.log("process with cost rel: - seqNo: " +  this.paramList.seqNo); 
           const seqNo = this.paramList.seqNo;
           const billngDate = this.convertDateForConfirm(item.chzEndDate,"-",false);
           //const billngDate = this.convertDateForConfirm(item.apptDate,"-",false);
           const endOfWeek   = moment(moment().endOf('week').toDate()).format('M/D/YYYY');
           //console.log("process with cost rel: - billngDate: " +  billngDate + ", endOfWeek: " + endOfWeek);
           try { 
             //await api.post("/api/w/apar/create", {
             await newAPIPost("/api/w/apar/create", {
               mode: "stageCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               salesOffice: this.paramList.salesOffice,
               deliveryOrder: item.deliveryOrder,
               refDoc: item.loadKeyWithStageNo,
               seqNo: seqNo,
               rateType: this.getRateCostCode(item.freightType),
               billingDate: billngDate,
               settleDate: dateFormat.getLocalDateOnly(endOfWeek) ,
               partner: this.getdriverUserNameFromDriver(item.driverId)
             })
             .then((res) => {
               //console.log("res body:" + res.body + " messages: " + res.messages[0]);
               console.log("res: " + JSON.stringify(res));
               item.stageStatus = "CFM";
               this.showDialog = true;
               this.$store.commit("clearApiError");
               window.confirm(res);
              //  this.doSearch();
             });
           } catch (err) {
              alert("Stage confirm error: " + err.messages[0]);
           }
         //   this.doSearch();
         }

         if (item.costRelevant == "Cost No Relevant(N)" || item.costRelevant == "Cost Relevant()" || item.costRelevant == null ){
           //console.log("process with no cost rel: - refDoc: " +  item.loadKeyWithStageNo); 
           try {
              //await api.post("/api/w/apar/create", {
              await newAPIPost("/api/w/apar/create", {
                mode: "stageCMN",
                user: "GST_SYSTEM",
                username: this.getUserProfile.username,
                refDoc: item.loadKeyWithStageNo
              })
              .then((res) => {
                //console.log("res body:" + res.body + " messages: " + res.messages[0]);
                console.log("res: " + JSON.stringify(res));
                item.stageStatus = "CMN";
                this.showDialog = true;
                this.$store.commit("clearApiError");
                window.confirm(res);
               //  this.doSearch();
              });
            } catch (err) {
               alert("Stage confirm error: " + err.messages[0]);
            }
         }
         }
         this.disableunconfirmstage = false;
      },

      doUnConfirmStage(item) {
         if (this.getStageStatusCode(item.stageStatus) != "CFM"){
            window.confirm('Stage Status is not CFM')
            return;
         }
         this.disableunconfirmstage = true;
         item.disablestageunconfirm = true;
           const seqNo = this.paramList.seqNo;
         //   const billngDate = this.paramList.chzEndDate;
           //api.post("/api/w/apar/create", {
           newAPIPost("/api/w/apar/create", {
             mode: "stageUnCFM",
             user: "GST_SYSTEM",
             username: this.getUserProfile.username,
             refDoc: item.loadKeyWithStageNo,
             seqNo: seqNo
           })
           .then((res) => {
             item.stageStatus = "DCP";
             this.showDialog = true;
             this.$store.commit("clearApiError");
             window.confirm(res);
             this.doSearch();
           });
           this.disableconfirmstage = false;
           item.disablestageconfirm = false;
           this.doSearch();
         
      },


   //  handleDropOffLocationChanged(item) {
   //      return (pickupLocation) => {
   //        if (pickupLocation) {
   //          item.ccicDropOffLocationCode = pickupLocation.tagId;
   //          item.containerDropOffLocation = pickupLocation.tagName;
   //          // item.pickUpLocation = pickupLocation;
   //        } else {
   //           //item.pickUpLocationId = null;
   //          // item.pickUpLocationName = null;
   //          // item.pickUpLocation = null;
   //        }
   //      };
   //    },


      // handlePickupLocationChanged(item) {
      //   return (pickupLocation) => {
      //     if (pickupLocation) {
      //       item.pickUpLocationCode = pickupLocation.tagId;
      //       item.pickUpLocationName = pickupLocation.tagName;
      //       // item.pickUpLocation = pickupLocation;
      //     } else {
      //        //item.pickUpLocationId = null;
      //       // item.pickUpLocationName = null;
      //       // item.pickUpLocation = null;
      //     }
      //   };
      // },


      // handleDeliverLocationChanged(item) {
      //   return (pickupLocation) => {
      //     if (pickupLocation) {
      //       item.deliverLocationCode = pickupLocation.tagId;
      //       item.deliverLocationName = pickupLocation.tagName;
      //       // item.pickUpLocation = pickupLocation;
      //     } else {
      //        //item.pickUpLocationId = null;
      //       // item.pickUpLocationName = null;
      //       // item.pickUpLocation = null;
      //     }
      //   };
      // },

        doCancel(item){
            this.restoreWithBackupItem(item);
            item.editing = false;
        },

        canEdit(item){
          return item.editing != null
      },

      async  doSearch()
    {   
        this.isfromsearch = true;
        if (this.params != null)
        {
            const data = {
            //loadKey: this.params.loadKey || this.params.seqNo,
            seqNo: this.params.seqNo,
            companyOffice: 'GST_' + this.params.salesOffice,
            salesOffice: this.params.salesOffice,
                }
            //console.log(data);
            //await api.post("/api/w/gst/WebSearchCockpit", data)
            await newAPIPost("/api/w/gst/WebSearchCockpit", data)
            //await api.post("/api/w/stc/dispatchstagelist", data)
          .then((items) => {
            this.$store.commit('clearApiError');
            if (items.length > 0) {
               this.paramList.loadStatus = items[0].loadStatus;
            }
            items.forEach((it) => {
            it.editing = false;
            it.showDropDown2 = false;
            it.show = true;
            it.remove = false;
            it.newitem = false;
            it.disableconfirmstage = false;
            // if (it.containerNo != it.emptyoutContainerNo) {
            //    it.containerNo = it.emptyoutContainerNo;
            // }
            // if (it.chassisNo != it.emptyoutChassisNo) {
            //    it.chassisNo = it.emptyoutChassisNo;
            // }
            it.driverId = this.getdriverFromUsername(it.driverId);
            it.freightType = this.getRateCostFromCode(it.freightType);
            it.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",it.chassisVendor);
            it.ctnrTygetBookingAssignpe = this.getDisplay("CCR_CNTRTYPE",it.ctnrType);
            it.apptDate = this.convertDateForDatePicker(it.apptDate);
            it.gwDate = this.convertDateForDatePicker(it.gwDate);
            it.inYardDate = this.convertDateForDatePicker(it.inYardDate);
            it.inGateDate = this.convertDateForDatePicker(it.inGateDate);
            it.chzEndDate = this.convertDateForDatePicker(it.chzEndDate);
            it.chzStartDate = this.convertDateForDatePicker(it.chzStartDate);
            it.chassisPickupLocation = this.getLocFromCode(it.chassisPickupLocation);
            it.chassisPickupTerm = this.getTermFromCode(it.chassisPickupTerm);
            it.chassisDropOffLocation = this.getLocFromCode(it.chassisDropOffLocation);
            it.chassisDropOffTerm = this.getTermFromCode(it.chassisDropOffTerm);
            it.stageStatus = this.getStageStatusFromCode(it.stageStatus);
            it.costRelevant = this.getCostRelFromCode(it.costRelevant);
            it.chassisSize = this.getChassisSizeFromCode(it.chassisSize);
            it.carrier = it.stageCarrier;
            //it.chzUseDay = this.getChassisUsedDate(it);
            it.chzUseDay = it.chzUseDay;
            if (it.ctnrPicConfirmed == "true")
                it.ctnrPicConfirmed = true;
            else
                it.ctnrPicConfirmed = false;
            if (it.chassisPicConfirmed == "true")
                it.chassisPicConfirmed = true;
            else
                it.chassisPicConfirmed = false;
            if (it.interTicketPicConfirmed == "true")
                it.interTicketPicConfirmed = true;
            else
                it.interTicketPicConfirmed = false; 
            if (it.stageType == "EO") {
               //console.log("stageType: " + it.stageType + ", bookingNo: " + it.bookingNo + ", stageBookingNo: " + it.stageBookingNo);    
               it.bookingNo = it.stageBookingNo;
            }                        
          });

            this.items = items;
            //console.log("Search: " + this.items)
            // this.items.forEach( (it) => {
            //    this.itemToHide.push(true);
            //    this.itemToHideStage.push(it.stage);
            // })
          });

        }
    },

    getBookingAssign(item) {
         //const loads = this.getSelectedItems
         //console.log("getBookingAssign")
         if (item.newitem) {
            alert("Please save the new item before process the assignment.");
            return;
         }   
         var loads = [];
         var bkAssignItem = item;
         bkAssignItem.ctnrType = this.getContentFromBrace(bkAssignItem.ctnrType);
         loads.push(bkAssignItem);
         //if (item.newitem) { alert("Please save the new record before process BK assign"); return; }
         if (this.paramList.carrier == null || this.paramList.grade == null) {
            alert("Either carrier or grade in container is empty, please setup info and assign again!!");
         } else {
            this.$refs.OutboundBooking.openDialog(loads);
            //item.bookingNo = "";
            //this.disableAsgBk = true;
            //this.disableUnAsgBk = false;
            //this.doChkRemoveAndSave(item);
         }
      },

    getBookingAssignEmptyOut(item) {
      //console.log("Empty out assign booking");
      if (item.newitem) {
         alert("Please save the new item before process the assignment.");
         return;
      }   
      var loads = [];
         var bkAssignItem = item;
         bkAssignItem.ctnrType = this.getContentFromBrace(bkAssignItem.ctnrType);
         loads.push(bkAssignItem);
         //if (item.newitem) { alert("Please save the new record before process BK assign"); return; }
         if (this.paramList.carrier == null) {
            alert("Either carrier or grade in container is empty, please setup info and assign again!!");
         } else {
            //console.log("calling empty out assign booking component");
            this.$refs.EmptyOutAssignBooking.openDialog(loads);
            //item.bookingNo = "";
            //this.disableAsgBk = true;
            //this.disableUnAsgBk = false;
            //this.doChkRemoveAndSave(item);
         }
    },

    getBookingUnAssign(item) {
         if (!window.confirm('Unassign Selected Items?')) {
           //this.disableAsgBk = true;
           //this.disableUnAsgBk = false; 
           return;
         }
        
         //const load = this.getSelectedItems
         // var loads = [];
         // loads.push(item);
         // const office = 'LGB'
         // const si = loads[0].deliveryOrder
         // const obk = loads[0].bookObl
         // const ibds = loads[0].ibs
         // const usr = 'GST_SYSTEM'
         // const seqn = loads[0].seqNo
         const office = 'LGB';
         const si = this.paramList.deliveryOrder;
         //const si = item.deliveryOrder;
         //const obk = this.paramList.bookingNo;
         const obk = item.bookingNo;
         const ibds = this.paramList.ibs;
         const usr = 'GST_SYSTEM';
         //const seqn = this.paramList.seqNo;
         const seqn = item.seqNo;
         //console.log("Set Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         //console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            //this.action(si, obk, 'UASN', seqn);
            item.bookingNo = "";
            item.deliveryOrder = "";
            item.bookingGrade = "";
            item.carrier = this.getContentFromBrace(this.paramList.carrier);
            this.paramList.bookingNo = "";
            this.paramList.loadBookingGrade = "";
            this.paramList.deliveryOrder = "";
            this.paramList.mismatchBooking = false;
            this.doChkRemoveAndSave(item);
 
         });
    },

    getBookingUnAssignEmptyOut(item) {
       console.log("Empty out unassign booking with DO: " + item.deliveryOrder);
       if (!window.confirm('Unassign Selected Items?')) {
           //this.disableAsgBk = true;
           //this.disableUnAsgBk = false; 
           return;
       }
       const office = 'LGB';
       //const si = this.paramList.deliveryOrder;
       const si = item.deliveryOrder;
       //const obk = this.paramList.bookingNo;
       //const obk = item.bookingNo;
       //const ibds = this.paramList.ibs;
       //const usr = 'GST_SYSTEM';
       //const seqn = this.paramList.seqNo;
       //const seqn = item.seqNo;
       const loadkeywithstageno = item.loadKeyWithStageNo;
       //console.log("Set Unassign");
       const request = {
         salesOffice: office,
         deliveryOrder: si,
         //ibs: ibds,
         //user: usr,
         //seqNo: seqn,
         loadKeyWithStageNo: loadkeywithstageno
       };

       //console.log(JSON.stringify(request));
       //api.post("/api/w/stc/WebStageUnAssignBooking", request).then((res) => {
       newAPIPost("/api/w/stc/WebStageUnAssignBooking", request).then((res) => {
         this.showDialog = false;
         this.$store.commit("clearApiError");
         //this.action(si, obk, 'UASN', seqn);
         item.bookingNo = "";
         item.deliveryOrder = "";
         item.bookingGrade = "";
         this.paramList.bookingNo = "";
         this.doChkRemoveAndSave(item);
 
       });

    },

    needLockLoad() {
        if (this.paramList.loadStatus === "BLC"
           || this.paramList.loadStatus === "CFM"
           || this.paramList.loadStatus === "LOK") {
            console.log("need Lock Load");
           return true;
           }   
        else {
           console.log("no need Lock Load"); 
           return false;   
        }   
    },

    needLockStage(item) {
       console.log("stage status: " + item.stageStatus); 
       if (this.getContentFromBrace(item.stageStatus) === "CCO"
           || this.getContentFromBrace(item.stageStatus) === "CFM"
           //|| this.getContentFromBrace(item.stageStatus) === "CMN"
           || this.getContentFromBrace(item.stageStatus) === "BLC"
           || this.getContentFromBrace(item.stageStatus) === "LOK") {
           console.log("need lock stage"); 
           return true;
           }   
        else {
           console.log("no need to lock stage"); 
           return false;
        }   
    },

    refreshLoadStatus(load) {
        //this.paramList.mode = this.params.mode;
        this.paramList.carrier = this.getDisplay("STC_CARRIER",load.carrier);
        this.paramList.loadKey = load.loadKey;
        this.paramList.route = load.route;
        this.paramList.deliveryOrder = load.deliveryOrder;
        this.paramList.ctnrType = this.getDisplay("CCR_CNTRTYPE",this.params.ctnrType);
        //this.paramList.ctnrType = this.params.ctnrType;
        this.paramList.cutLFD = this.params.cutLFD;
        this.paramList.loadStatus = this.params.loadStatus;
        this.paramList.customerOrder = this.params.customerOrder;
        this.paramList.containerNo = this.params.containerNo;
        this.paramList.chassisNo = this.params.chassisNo;
        this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
        this.paramList.appointment = this.params.appointment;
        //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
        this.paramList.apptDate = this.getDate(this.params.apptDate);
        this.paramList.apptTime = this.params.apptTime;
        this.paramList.salesOffice = this.params.salesOffice;
        this.paramList.seqNo = this.params.seqNo;
        this.paramList.bookingNo = this.params.bookingNo;
        this.paramList.receivingWindow = this.params.receivingWindow;
        this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
        //this.paramList.ctnrType = this.params.ctnrType;
        this.paramList.chzEndDate = this.convertDateForDatePicker(this.params.chzEndDate);
        this.paramList.chzStartDate = this.convertDateForDatePicker(this.params.chzStartDate);
        this.paramList.dispatcher = this.params.createdBy;
        this.paramList.sealNumber = this.params.sealNumber;
        this.paramList.driverGroup = this.params.driverGroup;
        this.paramList.driverId = this.params.driverId;
        this.paramList.custId = this.params.custID;
        this.paramList.usedDay = this.getChassisUsedDate(this.params);
        this.paramList.inYardDate = this.params.inYardDate;
        this.paramList.grade = this.params.grade;
        //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
        //this.paramList.ctnrPickup = this.params.containerPickupLocation;
        this.paramList.ctnrDropOff = this.params.dropOffTerm;
        this.paramList.ctnrPickup = this.params.pickupTerm;
        this.paramList.gwDate = this.getDate(this.params.gwDate);
        this.paramList.bolNum = this.params.bolNum;
        this.paramList.doProcess = this.params.doProcess;
        this.paramList.emptyoutContainerNo = this.params.emptyoutContainerNo;
        this.paramList.emptyoutChassisNo = this.params.emptyoutChassisNo;

    },

    saveBackupItem(item) {
      this.backupItem.loadStatus = item.loadStatus,
      this.backupItem.stageStatus = item.stageStatus,
      this.backupItem.containerNo = item.containerNo,
      this.backupItem.chassisNo = item.chassisNo,
      this.backupItem.carrier = item.carrier,
      this.backupItem.moveInDate = item.moveInDate,
      this.backupItem.chzStartDate = item.chzStartDate,
      this.backupItem.chzEndDate = item.chzEndDate,
      this.backupItem.chzUseDay = item.chzUseDay,
      this.backupItem.deliveryOrder = item.deliveryOrder,
      this.backupItem.stageTypeWithStatus = item.stageTypeWithStatus,
      this.backupItem.apptDate = item.apptDate,
      this.backupItem.apptTime = item.apptTime,
      this.backupItem.appointment = item.appointment,
      this.backupItem.pickupDate = item.pickupDate,
      this.backupItem.driverId = item.driverId,
      this.backupItem.truckId = item.truckId,
      this.backupItem.costRelevant = item.costRelevant,
      this.backupItem.freightType = item.freightType,
      this.backupItem.pickupLocationCode = item.pickupLocationCode,
      this.backupItem.pickUpLocationName = item.pickUpLocationName,
      this.backupItem.deliverLocationCode = item.deliverLocationCode,
      this.backupItem.deliverLocationName = item.deliverLocationName,
      this.backupItem.dispatcherInstruction = item.dispatcherInstruction,
      this.backupItem.containerPickupLocation = item.containerPickupLocation,
      this.backupItem.containerDropOffLocation = item.containerDropOffLocation,
      this.backupItem.offsiteScale = item.offsiteScale,
      this.backupItem.ccicDropOffLocationCode = item.ccicDropOffLocationCode,
      this.backupItem.bookingNo = item.bookingNo,
      this.backupItem.stageBookingNo = item.stageBookingNo,
      this.backupItem.customerOrder = item.customerOrder,
      this.backupItem.ctnrtype = item.ctnrType,
      this.backupItem.cutLFD = item.cutLFD,
      this.backupItem.pickupLoc = item.pickupLoc,
      this.backupItem.deliveryTo = item.deliveryTo,
      this.backupItem.grade = item.grade,
      this.backupItem.weight = item.weight,
      this.backupItem.sealNumber = item.sealNumber,
      this.backupItem.pickupTerm = item.pickupTerm,
      this.backupItem.dropOffTerm = item.dropOffTerm,
      this.backupItem.bolNum = item.bolNum,
      this.backupItem.inYardDate = item.inYardDate,
      this.backupItem.chassisVendor = item.chassisVendor,
      this.backupItem.chassisPickupLocation = item.chassisPickupLocation,
      this.backupItem.chassisDropOffLocation = item.chassisDropOffLocation,
      this.backupItem.chassisPickupTerm = item.chassisPickupTerm,
      this.backupItem.chassisDropOffTerm = item.chassisDropOffTerm,
      this.backupItem.chassisSize = item.chassisSize,
      this.backupItem.inGateDate = item.inGateDate,
      this.backupItem.emptyoutContainerNo = item.emptyoutContainerNo,
      this.backupItem.emptyoutChassisNo = item.emptyoutChassisNo,
      this.backupItem.custID = item.custID,
      this.backupItem.newLoadKey = item.newLoadKey,
      this.backupItem.dropoffTermLocDes = item.dropoffTermLocDes,
      this.backupItem.pickupTermLocDes = item.pickupTermLocDes

    },

    restoreWithBackupItem(item) {
      item.loadStatus = this.backupItem.loadStatus,
      item.stageStatus = this.getStageStatusFromCode(this.backupItem.stageStatus),
      item.containerNo = this.backupItem.containerNo,
      item.chassisNo = this.backupItem.chassisNo,
      item.carrier = this.backupItem.carrier,
      item.moveInDate = this.backupItem.moveInDate,
      item.chzStartDate = this.convertDateForDatePicker(this.backupItem.chzStartDate),
      item.chzEndDate = this.convertDateForDatePicker(this.backupItem.chzEndDate),
      item.chzUseDay = this.backupItem.chzUseDay,
      item.deliveryOrder = this.backupItem.deliveryOrder,
      item.stageTypeWithStatus = this.backupItem.stageTypeWithStatus,
      item.apptDate = this.convertDateForDatePicker(this.backupItem.apptDate),
      item.apptTime = this.backupItem.apptTime,
      item.appointment = this.backupItem.appointment,
      item.pickupDate = this.backupItem.pickupDate,
      item.driverId = this.getdriverFromUsername(this.backupItem.driverId),
      item.truckId = this.backupItem.truckId,
      item.costRelevant = this.getCostRelFromCode(this.backupItem.costRelevant),
      item.freightType = this.getRateCostFromCode(this.backupItem.freightType),
      item.pickupLocationCode = this.backupItem.pickupLocationCode,
      item.pickUpLocationName = this.backupItem.pickUpLocationName,
      item.deliverLocationCode = this.backupItem.deliverLocationCode,
      item.deliverLocationName = this.backupItem.deliverLocationName,
      item.dispatcherInstruction = this.backupItem.dispatcherInstruction,
      item.containerPickupLocation = this.backupItem.containerPickupLocation,
      item.containerDropOffLocation = this.backupItem.containerDropOffLocation,
      item.offsiteScale = this.backupItem.offsiteScale,
      item.ccicDropOffLocationCode = this.backupItem.ccicDropOffLocationCode,
      item.bookingNo = this.backupItem.bookingNo,
      item.stageBookingNo = this.backupItem.stageBookingNo,
      item.customerOrder = this.backupItem.customerOrder,
      item.ctnrType = this.backupItem.ctnrtype,
      item.cutLFD = this.backupItem.cutLFD,
      item.pickupLoc = this.backupItem.pickupLoc,
      item.deliveryTo = this.backupItem.deliveryTo,
      item.grade = this.backupItem.grade,
      item.weight = this.backupItem.weight,
      item.sealNumber = this.backupItem.sealNumber,
      item.pickupTerm = this.backupItem.pickupTerm,
      item.dropOffTerm = this.backupItem.dropOffTerm,
      item.bolNum = this.backupItem.bolNum,
      item.inYardDate = this.convertDateForDatePicker(this.backupItem.inYardDate),
      item.chassisVendor = this.backupItem.chassisVendor,
      item.chassisPickupLocation = this.getLocFromCode(this.backupItem.chassisPickupLocation),
      item.chassisDropOffLocation = this.getLocFromCode(this.backupItem.chassisDropOffLocation),
      item.chassisPickupTerm = this.getTermFromCode(this.backupItem.chassisPickupTerm),
      item.chassisDropOffTerm = this.getTermFromCode(this.backupItem.chassisDropOffTerm),
      item.chassisSize = this.getChassisSizeFromCode(this.backupItem.chassisSize),
      item.inGateDate = this.backupItem.inGateDate,
      item.emptyoutContainerNo = this.backupItem.emptyoutContainerNo,
      item.emptyoutChassisNo = this.backupItem.emptyoutChassisNo,
      item.custID = this.backupItem.custID,
      item.newLoadKey = this.backupItem.newLoadKey,
      item.dropoffTermLocDes = this.backupItem.dropoffTermLocDes,
      item.pickupTermLocDes = this.backupItem.pickupTermLocDes

    },

   

    convertDateForDatePicker(date) {
        var day = "";
        var month = "";
        var year = "";

        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          if (date.indexOf("T") < 1 && date.indexOf("-") > 1) date = date + "T00:00:00" 
          console.log("date input after checking with T: " + date);
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          //month = processDate.getMonth();
          day = processDate.getDate();
          //console.log("date input before process:- year: " + year + ", month: " + month + ", date: " + day );
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          return date;
        }
     },

     convertDateForConfirm(date, separator,needTime) {
        var day = "";
        var month = "";
        var year = "";
        var hour = "";
        var minute = "";
        var second = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          hour = processDate.getHours();
          minute = processDate.getMinutes();
          second = processDate.getSeconds();
          console.log(`hour: ${hour.toString()} min: ${minute.toString()} sec: ${second.toString()}`);
          console.log(`hour length: ${hour.toString().length} min length: ${minute.toString().length} sec length: ${second.toString().length}`);
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          if (hour && hour.toString().length < 2)
          {
             hour = "0" + hour;
             console.log(`added leading zero to hour: ${hour}`);
          }
          if (minute && minute.toString().length < 2)
          {
             minute = "0" + minute;
            console.log(`added leading zero to min: ${minute}`);
          }
          if (second && second.toString().length < 2)
          {
             second = "0" + second;
             console.log(`added leading zero to sec: ${second}`);
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          if (separator && separator == "-")
             if (needTime)
             {
                //return `${year}${separator}${month}${separator}${day}T${hour}:${minute}:${second}` 
                return moment(processDate).format("YYYY-MM-DDTHH:mm:ss");
             } else {
                //return year + separator + month + separator + day;
                return moment(processDate).format('YYYY-MM-DD');
             } 
          else
             if (needTime)
             {
                //return `${year}/${month}/${day} ${hour}:${minute}:${second}`
                return moment(processDate).format("YYYY/MM/DDTHH:mm:ss");
             } else {
                //return month + "/" + day + "/" + year;
                return moment(processDate).format('YYYY/MM/DD');
             } 
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
      },

    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },

    getdriverUserNameFromDriver(driver) {
         return this.getContentFromBrace(driver);
    },

    getRateCostCode(RateCost) {
         var retVal = this.getContentFromBrace(RateCost);
         //console.log("Rate cost return: " + retVal);
         return retVal;
    },

    getchassisVendorCode(vendor) {
         return this.getContentFromBrace(vendor);
    },

    getChassisSizeCode(size) {
         return this.getContentFromBrace(size);
    },
    
    getStageStatusCode(status) {
         return this.getContentFromBrace(status);
    },
    getSTCTerminal() {
         //const terminals = this.getMasterDataByGroup("GST_TERMINAL").filter( it => it.from == "STC");
         const terminals = this.getMasterDataByGroup("STC_TERMINAL");
         //console.log("termainals: " + JSON.stringify(terminals));
         //var retTerm = [];
         terminals.forEach((it) => {
            //console.log("termname: " + it.tagName + ", term id" + it.tagId);
            this.terminals.push(it.tagName + "(" + it.tagId + ")");
         })
         //console.log("this terminals: " + this.terminals);
         //return retTerm;
    },
    getdriverFromUsername(username) {
         var indx = 0;
         var findIndx = -1;
         if (username && username != "") {
            this.driverNames.forEach( (it) => {
               if (it == username) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.drivers[findIndx];
            } else {
               return username;
            }
         } else {
            return username;
         }
    },
    getdriverMobileFromUsername(username) {
         var indx = 0;
         var findIndx = -1;
         if (username && username != "") {
            this.driverNames.forEach( (it) => {
               if (it == username) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.driverContact[findIndx];
            } else {
               return null;
            }
         } else {
            return null;
         }
    },
    getLocFromCode(code) {
       var tagname = this.getMasterDataName("GST_LOCATION",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getTermFromCode(code) {
      var tagname = this.getMasterDataName("STC_TERMINAL",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getStageStatusFromCode(code) {
      var tagname = this.getMasterDataName("GST_STAGE_STATUS",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getCostRelFromCode(code) {
      var tagname = this.getMasterDataName("STC_COSTREL_STATUS",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getChassisSizeFromCode(code) {
      var tagname = this.getMasterDataName("CCR_CNTRTYPE",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;

    },
    getRateCostFromCode(code) {
         var indx = 0;
         var findIndx = -1;
         if (code && code != "") {
            this.dispRateCostCodes.forEach( (it) => {
               if (it == code) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.dispRateCostList[findIndx];
            } else {
               return code;
            }
         } else {
            return code;
         }
    },

    getDisplay(group, tagId) {
      var tagname = "";
      if (!tagId) {
        return "";
      }
      tagname = this.getMasterDataName(group, tagId) || tagId;
      //console.log("getdisplay tagname: " + tagname);
      return tagname + " (" + tagId + ")";
    },

    getStageTypeInfo(type) {
       var retType = "";
       //console.log("in stage type: " + type);
       if (type && type != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          //console.log("return type: " + retType);
       }
       if (retType == "") {
          return "In Gate";
       }   
       else {
          return retType;     
       }
    },
    getPushStatusInfo(status) {
       var retStatus = "";
       //console.log("push status: " + status);
       if (status && status != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retStatus = this.getMasterDataName("PUSH_STATUS",status);
          //console.log("return type: " + retStatus);
       }
       return retStatus;     
    },
    setStageWindow(type) {
       if (type == "I" || type == "O" || type == "T") {
          this.showChzOut = false;
          this.showInOutTrans = true;
       } else {
         if (type == "CO") {
             this.showChzOut = true;
             this.showInOutTrans = false;
         }
         else {
             this.showChzOut = false;
             this.showInOutTrans = false;
         }
       }

          
    },
    getFreightType() {
        return  this.getMasterDataAsSelectOptionByGroup('GST_RATE_COST');
        
      },
    initShowStageType() {
       this.showLISel = false;
       this.showLOSel = false;
       this.showEISel = false;
       this.showEOSel = false;
       this.showCISel = false;
       this.showCOSel = false;
       this.showTSel = false;
       this.showRSel = false;
    },  

    checkStageTypeListOpt(type) {
      var group = "STC_LOAD_STAGES_" + type;
      console.log("load stages group: " + group);
      const opts =  this.getMasterDataByGroup(group);
      //console.log("stage type opt: " + opts + " opt length: " + opts.length); 
      this.initShowStageType();
      if (opts && opts.length >= 0) {
         var opt = opts[0];      
         var tagid = "";
         for (opt in opts) {
            //console.log("load stage: " + opts[opt].tagId);
            tagid = opts[opt].tagId;
            if (tagid == "LI") this.showLISel = true;
            if (tagid == "LO") this.showLOSel = true;
            if (tagid == "EI") this.showEISel = true;
            if (tagid == "EO") this.showEOSel = true;
            if (tagid == "CI") this.showCISel = true;
            if (tagid == "CO") this.showCOSel = true;
            if (tagid == "R") this.showRSel = true;
            if (tagid == "T") this.showTSel = true;
         }
      }
      // for (var opt in opts) {
      //    console.log("stages: " + opt);
      // }
      // opts.forEach( (it) => {
      //    console.log("opts loop");
      //    if (it.tagId == "LI") this.showLISel = true; else this.showLISel = false;
      //    if (it.tagId == "LO") this.showLOSel = true; else this.showLOSel = false;
      //    if (it.tagId == "EI") this.showEISel = true; else this.showEISel = false;
      //    if (it.tagId == "EO") this.showEOSel = true; else this.showEOSel = false;
      //    if (it.tagId == "CI") this.showCISel = true; else this.showCISel = false;
      //    if (it.tagId == "CO") this.showCOSel = true; else this.showCOSel = false;
      //    if (it.tagId == "T") this.showTSel = true; else this.showTSel = false; 
      // })
    },

    isToShowInOutTrans(type) {
      if (type == "I" || type == "O" || type == "T") 
         return true;
      else 
         return false;
    },
    isToShowChzOut(type) {
      if (type == "CO") 
         return true;
      else 
         return false;
    },
    isToShowLoadIn(type) {
      //console.log("isToShowLoadIn type: " + type);
      if (type == "LI")
        return true;
      else
        return false;  
    },
    isToShowLoadOut(type) {
      if (type == "LO")
         return true;
      else
         return false;   
    },
    isToShowEmptyOut(type) {
      if (type == "EO")
         return true;
      else
         return false;   
    },
    isToShowEmptyIn(type) {
      if (type == "EI")
         return true;
      else
         return false;   
    },
    isToShowChassisOut(type) {
      if (type == "CO")
         return true;
      else
         return false;   
    },
    isToShowChassisIn(type) {
      if (type == "CI")
         return true;
      else
         return false;   
    },
    isToShowTransfer(type) {
      if (type == "T")
         return true;
      else
         return false;   
    },
    isToShowReuse(type) {
      if (type == "R")
         return true;
      else
         return false;   
    },

    getDate(date) {
      var separator = "T";
      if (date) {
         if (date.toString().indexOf(separator) > 0) {
            return date.toString().substr(0,date.toString().indexOf(separator));
         }
         else
         {
            return date.toString();
         }         
      }
      else {
         return "";
      }

    },
   //  getChassisUsedDate(item){
   //        console.log("chzStartDate: " + item.chzStartDate + " chzEndDate: " + item.chzEndDate);
   //        if (item.chzEndDate == null)
   //        {
   //          return moment().diff(moment(item.chzStartDate), 'days') + " days";
   //        }
   //        else
   //        {
   //          return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + " days";
   //        }
   //    },
      doDropDown() {
          this.showDropDown = !this.showDropDown;
      },
      doDropDown2(item) {
          if (item.showDropDown2 == null) {
             item.showDropDown2 = true;
             //console.log("dodropdown2 is null and set: " + item.showDropDown2); 
          }   
          else {   
             console.log("dodropdown2 is: " + item.showDropDown2); 
             item.showDropDown2 = !item.showDropDown2; 
             //console.log("dodropdown2 is now: " + item.showDropDown2); 
          }   
      }, 
      doHide() {
          this.loadHide = !this.loadHide;
      },     
      toShowDropDown2(item) {
         //console.log("toshowdropdown2: ",item);
         if (item.showDropDown2) { 
            //console.log('showdropdown2 return true'); 
            return true;}
         else {
            //console.log('showdropdown2 return false'); 
            return false;}
      } 
    }
    }



</script>

<style scoped>

.custButton {
    margin: 10px;
    width: 110px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.custLongButton {
    margin: 10px;
    width: 180px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}


.holder {
    /* background: blue; */
    margin: 20px;
    width: 800px;
    height: 200px;
}

.header{
    text-align: left;
}

.fixed-content {
    padding-left: 10%;
    padding-right: 10%;
    position:fixed;
    overflow-y:auto;
    overflow-x:hidden;
}

.md-layout-item {
  height: 50px;
  margin-top: 8px;
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* border:1px solid #000; */
  /* background: #ce93d8; */
}

.md-title {
    margin-left: 20px;


}

.fieldWidth {
   width: 80px !important;
}





</style>